<template>
  <div :class="modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3'">
      <div v-if="!modalMode">
          <breadCrumb :routesArray="routesArray"></breadCrumb>
      </div>
      <div class="row w-full flex-shrink-0 flex mt-2" v-if="!modalMode">
          <div class="w-7/12"><h1 class="title" :class="titleLength > 40? 'table-ellipsis':''">{{presentTaskObject.controlTitle}}</h1></div>
          <!-- <div class="flex w-3/5 justify-between">
            <div>
              <p class="text-sm">
                Id : <b>{{ presentComplianceObject.complianceId }}</b>
              </p>
            </div>
            <div>
              <p class="text-sm">
                Title : <b>{{ presentComplianceObject.title }}</b>
              </p>
            </div>
          </div> -->
      </div>
    
      
    <div class="w-full minheight">
      <div class="text-sm">
        <div>
          <div class="mainContainer tabStructure w-full bg-white border rounded-sm mt-5 pb-3 px-5 pt-5 border-lightgrey flex">
            <Tabs  v-model:value="selectedTabIndex" scrollable class="w-80 pr-5">
              <div>
                <TabList >
                    <Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
                        {{ tab.displayName }}
                    </Tab>
                </TabList>
              </div>
            
            <TabPanels class=" overflow-auto  hide-scrollbar">
              <TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
                
                <div v-if="tabDataLoading == true">
                  <div class="flex items-center justify-center w-full h-16 skeleton">
                    <dots-loader/>
                  </div>
                </div>
                <div v-else class="h-full min-h-0">
                  <div class="descriptionToggle overflow-y-auto">
                    <div v-if="tab.id == 1">
                        <div>
                                <div>
                                  <div class="border-b border-lightgrey">
                                      <p class="mt-3 mb-1.5 header">Control Info</p>
                                  </div>
                                </div>
                                <!-- <div class="flex flex-row w-full pt-2">
                                <div class="controllabel flex items-center border-l border-t border-r w-20 border-b p-2 header border-lightgrey rounded-l-sm">CID</div>
                                <div class="w-30 border-t border-r border-b p-2 text-xs font-extrabold border-lightgrey">
                                   <div class="pl-3 flex items-center flex-wrap">
                                  <div :class="[getBorder(), 'text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center']">
                                  {{ presentTaskObject.controlNumber }}
                                </div>
                                </div> 
                                {{ presentTaskObject.clientUniqueId != undefined ? presentTaskObject.clientUniqueId : 'N/A' }}
                                </div>
                                <div class="controllabel  flex items-center border-t border-r border-b p-2 header border-lightgrey w-23">Frequency</div>
                                <div class="w-27 border-t border-r border-b p-2 header border-lightgrey w-23 rounded-r-sm" v-if="presentTaskObject.controlFrequency">
                                  {{
                                    controlFrequencyArray.find((l) => l.id == presentTaskObject.controlFrequency)?.label
                                  }}
                                </div>
                                <div v-else class="w-27 border-t border-r border-b p-2 header border-lightgrey w-23 rounded-r-sm flex justify-center items-center">
                                  <div>N/A</div>
                                </div>
                            </div> -->
                            <div class="flex">
                              <div class="w-6/12">
                                <p class="font-extrabold mt-2.5 mb-1 text-xs">CID</p>
                                <p class="mt-1 mb-3 text-sm">{{ presentTaskObject.clientUniqueId != undefined|| presentTaskObject.clientUniqueId!='' ? presentTaskObject.clientUniqueId : 'N/A'}}</p>
                              </div>
                              <div class="w-6/12">
                                <p class="font-extrabold mt-2.5 mb-1 text-xs">Frequency</p>
                                <p v-if="(presentTaskObject.controlFrequency)" class="mt-1 mb-3 text-sm">{{dbFrequency.find((l) => l.value == presentTaskObject.controlFrequency)?.key||'N/A'}}</p>
                                <p class="text-sm mt-1 mb-3" v-else>N/A</p>
                              </div>
                              
                            </div>
                            </div>
                            <div class="flex">
                                <div class="w-6/12">
                                    <p class="font-extrabold mb-1 text-xs">Title</p>
                                    <p class="mt-1 mb-3 text-sm">{{presentTaskObject?.controlTitle||'N/A' }}</p>
                                </div>
                                <div class="w-6/12">
                                  <p class="font-extrabold mb-1 text-xs">Type</p>
                                  <p class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlType||'N/A' }}</p>
                                </div>
                            </div>
                          
                            <div class="flex">
                              <div class="w-6/12">
                                <p class="font-extrabold mb-1 text-xs">Class</p>
                                <p v-if="(presentTaskObject?.controlClass)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlClass||'N/A' }}</p>
                                <p v-else class="text-sm mt-1 mb-3">N/A</p>
                              </div>
                              <div class="w-6/12">
                                <p class="font-extrabold mb-1 text-xs">Family</p>
                                <p v-if="(presentTaskObject?.controlFamily)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlFamily||'N/A' }}</p>
                                <p v-else class="text-sm mt-1 mb-3">N/A</p>
                              </div>

                            </div>
                            <div class="flex flex-row"> 
                              <div class="w-6/12">
                                <label class="font-extrabold text-xs">Priority</label>
                                <div v-if="presentTaskObject?.controlPriority && typeof presentTaskObject?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentTaskObject?.controlPriority)">
                                  <div class="text-xs" :class="colorLabelText(presentTaskObject?.controlPriority)">
                                  {{ getProirityLabel(presentTaskObject?.controlPriority) }}
                                  </div>
                                </div>
                                <div v-else class="text-sm mt-2">N/A</div>
                              </div>
                            </div>
                            <div> 
                              <label class="font-extrabold mt-2 text-xs">Description</label>
                              <p v-if="(presentTaskObject?.Description)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.Description||'N/A' }}</p>
                              <p v-else class="text-sm mt-1 mb-3">N/A</p>
                            </div>
                            <div> 
                              <label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
                              <p v-if="(presentTaskObject?.controlPolicies)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlPolicies||'N/A' }}</p>
                              <p v-else class="text-sm mt-1 mb-3">N/A</p>
                            </div>
                            <div>
                              <label class="font-extrabold mt-2 mb-1 text-xs">Guidance</label>
                              <p v-if="(presentTaskObject?.controlGuidance)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlGuidance||'N/A' }}</p>
                              <p v-else class="text-sm mt-1 mb-3">N/A</p>
                            </div>
                            <div> 
                              <label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
                              <p v-if="(presentTaskObject?.controlMaintenanceTask)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlMaintenanceTask||'N/A' }}</p>
                              <p v-else class="text-sm mt-1 mb-3">N/A</p>
                            </div>
                          <div v-for="control in controlsArray" :key="control.framework" class="pt-2 pb-3">
                            <div v-for="detail in control.controlsDetailsArray" :key="detail.controlNumber">
                              <div class="border-b border-lightgrey flex flex-row">
                                <p class="text-xs py-0.5 bg-white font-bold h-auto flex items-center my-1.5 header">{{ control.framework }}</p>
                              </div>
                              <div class="flex items-center">
                                <div class="flex flex-row w-50 mt-2 mb-2">
                                <div class="w-50 border-t border-l border-r border-b p-2 header border-lightgrey rounded-l-sm">
                                <label class="controllabel">Number</label>
                                </div>
                                  <div class="w-50 border-t border-r border-b p-2 header border-lightgrey rounded-r-sm">
                                  <div class="pl-3 flex items-center flex-wrap">
                                  <div :class="[getBorder(), 'text-xs px-2 py-0.5 bg-white font-bold h-auto flex items-center']">
                                  {{ detail.controlNumber }}
                                </div>
                                </div>
                                </div>
                              </div>
                              </div>
                                <div class="border-b border-lightgrey">
                                    <p class="my-1.5 header">Description</p>
                                </div>
                                <p v-if="detail.description == null || detail.description == undefined" class="mt-1.5 text-xs">{{ 'N/A' }}</p>
                                <p v-else class="mt-1.5 text-xs">{{detail.description}}</p>
                                <!-- <label class="controllabel">Description </label>
                                <div class="paddingforDescription paddingrightforDescription">:</div>
                                <div class="text-xs">{{detail.description}}</div> -->
                              </div>
                            </div>
                          <div v-if="kpisObject && kpisObject.length > 0">
                          <div class="border-b border-lightgrey">
                            <p class="my-1.5 header">KPI</p>
                          </div>
                          <div class="flex flex-row w-full pt-2">
                          <div class="border-l border-t border-r w-20 border-b p-2 header border-lightgrey rounded-l-sm">Name</div>
                          <div class="w-30 border-t border-r border-b p-2 header border-lightgrey">{{ kpisObject[0].description != undefined ? kpisObject[0].description : 'N/A' }}</div>
                          <div class="controllabel border-t border-r border-b p-2 header border-lightgrey w-23">Weightage (%)</div>
                          <div class="w-27 border-t border-r border-b p-2 header border-lightgrey w-23 rounded-r-sm"> <div class="pl-20">{{ kpisObject[0].weightage != undefined ? kpisObject[0].weightage : 'N/A' }}</div></div>
                          </div>
                          </div>
                    </div>
                    <div v-if="tab.id==2">
                      <div>
                                <div class="border-b border-lightgrey">
                                    <p class="mt-3 mb-1.5 header">Documents which are related to the controls</p>
                                </div>
                                <!-- <p class="mt-1.5">{{ descriptionObject._id }}</p> -->
                        </div>
                    </div>
                    <div v-if="tab.id==3">
                      <div class="flex justify-between border-b border-lightgrey mt-2">
                            <div><p class="my-1.5 header">Related Tasks</p></div>
                            <button class="flex justify-between items-center" @click="filterOpen" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none': 'filterButton flex justify-center '">
                                <img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                                <img v-else src="@/assets/filter.svg" class="filterIcon" /> 
                                Filters
                            </button>
                          </div>
                          <tableData :tableRowData="tableRow" :headersData="Headers"></tableData>
                    </div>
                    <div v-if="tab.id==4">
                      <div>
                                <!-- <div class="border-b border-lightgrey flex justify-end onepixel">
                                    <div><p class="my-1.5 header">Files uploaded by Auditee/Asignee for Evidence</p></div>
                                    <div class="mb-1.5">
                                        <div class="buttonposition flex justify-center items-center">
                                            <button @click="openFilePicker" :class="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418 ||  TaskDetailsDropDown.taskStatus == 10401 ? 'btndisabled pointer-events-none paddingForAttachButton': 'btnprimary flex justify-center taskEditButtons'" for="upload" class="w-24">Attach</button>
                                            <input type="file" ref="fileInput" id="upload" @change.stop="handleFileChange" style="display: none" />
                                        </div>
                                    </div>
                                </div> -->
                                <div class="border-b border-lightgrey">
                                    <div class="flex justify-between mt-2">
                                        <div class="my-1.5 header">Files</div>
                                        <div class="flex gap-2">
                                          <button @click="openLinkEvidencePopup" :class="isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center'">Link Existing</button>
                                          <button @click="openFilePicker" :class="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418 ||  TaskDetailsDropDown.taskStatus == 10401 ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center'" for="upload" >Attach</button>
                                        </div>
                                </div>
                                </div>
                                <!-- <p class="mt-1.5">Files</p> -->
                                <div v-if="Object.keys(presentTaskObject).includes('files')" class="flex mt-5 gap-4 flex-wrap">
                                    <div v-for="doc in presentTaskObject.files" :key="doc">
                                        <div class="pdf w-full rounded-sm">
                                            <a :href="doc.url" class="flex w-full flex-row items-center">
                                                <img src="@/assets/pdfs.svg" alt="" />
                                                <div class="flex flex-col w-full min-w-0">
                                                  <p v-if="Object.keys(doc).includes('filename')" class="text-xs ml-2">{{doc.filename}}</p>
                                                  <p v-else class="text-xs ml-1">{{ doc.name }}</p>
                                                  <p v-if="doc.taskId" class="ml-2 fontSize10PX font-semibold">{{ doc.taskId }}</p>
                                                </div>
                                                <button type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentTaskObject.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
                                                  <img src="@/assets/deleteIcon.svg" alt="Delete" />
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div v-if="tab.id==5">
                      <div>
                                <div class="border-b border-lightgrey flex justify-between mt-2">
                                    <div><p class="my-1.5 header">Comments</p></div>
                                    <div>
                                        <div class="buttonposition flex justify-center items-center">
                                            <div class="buttonposition flex justify-center items-center">
                                                <button class="filterButton flex " v-if="oldComments" @click="sortComments()" :class="Object.keys(this.presentTaskObject).includes('comments') && this.presentTaskObject.comments.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none'">
                                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                                    Oldest
                                                </button>
                                                <button class="filterButton flex " v-if="!oldComments" @click="sortComments()">
                                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                                    Newest
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="comment-box w-full">
                                        <div class="my-5">
                                            <!-- <textarea placeholder="Add a Comment" class="w-full border border-lightgrey text-sm rounded-sm p-2 text-xs" rows="4" :disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418" v-model="comment" @input="handleInput"></textarea> -->
                                            <!-- <div ref="editorContainer" class="editor-container"></div> -->
                                            <commentsEditor  v-if="TaskDetailsDropDown.taskStatus!=10403 && TaskDetailsDropDown.taskStatus!=10418 && TaskDetailsDropDown.taskStatus!=10417" :taskStatusCode="TaskDetailsDropDown.taskStatus"/>
                                          </div>
                                    </div>
                                    <div v-if="Object.keys(presentTaskObject).includes('comments')" class="comments">
                                        <div v-for="(obj, index) in presentTaskObject.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2" :key="index">
                                            <div class="w-1/5">
                                                <div class="header">{{ getPersonName(obj.createdBy) }}</div>
                                                <div class="fontSize10PX">{{formatTime( obj.createdAt )}}</div>
                                            </div>
                                            <!-- <div class="w-4/5 text-xs">{{ obj.comment }}</div> -->
                                            <!-- <div class="w-4/5 text-xs" v-html="obj.comment"></div> -->
                                            <div class="w-4/5 text-xs">
                                              <safeHtml :content="obj.comment"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div v-if="tab.id==6">
                      <div>
                                <div class="border-b border-lightgrey">
                                    <div class="flex justify-between mt-2">
                                        <div class="my-1.5 header">Findings</div>
                                        <div><button @click="showpopupOnAdd()" :class="(TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418) || presentTaskObject.reviewer != userInfo._id || TaskDetailsDropDown.taskStatus == 10401 ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center'">Add Findings</button></div>
                                    </div>
                                </div>
                                <div  v-if="Object.keys(presentTaskObject).includes('findings')" class="">
                                    <!-- (this.findingsObject.actualOutput = ''), (this.findingsObject.totalPopulation = ''), (this.findingsObject.finding = ''); -->
                                  <div v-for="(obj, index) in findingsForCompliance" :key="index" class="w-full h-auto mt-5">
                                      <!-- <div class="row flex flex-row w-full">
                                          <div class="w-6/12">
                                              <div class="pb-2">
                                                  <label class="controllabel">Total Population</label>
                                                  <p>{{ obj.totalPopulation }}</p>
                                              </div>
                                              <div class="pb-2">
                                                  <label class="controllabel">Actual Output</label>
                                                  <p>{{ obj.actualOutput }}</p>
                                              </div>
                                          </div>
                                          <div class="w-6/12 flex items-center">
                                              <div class="pb-2">
                                                  <label class="controllabel">Performance Output</label>
                                                  <p>{{ obj.actualOutput }}</p>
                                              </div>
                                          </div>
                                      </div>
                                      <p class="mr-2 pb-2 pt-2">Comments : {{ obj.comments }}</p> -->
                                      <!-- <p class="mr-2 pt-2">Evidence - {{index+1}} : {{ obj.findingEvidence }}</p> -->

                                      <div class="flex flex-row">
                                        <div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">Finding ID</div>
                                        <div  class="border header border-lightgrey w-77 p-2 rounded-tr-md text-xs">
                                            {{obj.findingId?.toUpperCase()}}
                                        </div>
                                      </div>
                                      <div class="flex flex-row">
                                          <div class="border-l border-b p-2 header w-23 border-lightgrey">Finding</div> 
                                          <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs">{{ obj.finding }}</div>
                                      </div>
                                      <div class="flex flex-row">
                                          <div class="border-l border-b p-2 header w-23 border-lightgrey">Evidence</div> 
                                          <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs">{{ obj.findingEvidence }}</div>
                                      </div>
                                      <div class="flex flex-row">
                                          <div class="border-l border-b p-2 header w-23 border-lightgrey">Related To</div> 
                                          <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs">{{ getFindingRelatedToDisplay(obj.findingRelatedTo) }}</div>
                                      </div>
                                      <div class="flex flex-row">
                                          <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">{{ getFindingLinkFieldLabel(obj) }}</div> 
                                          <div  class="border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md text-xs">{{ getFindingLinkDisplay(obj) }}</div>
                                      </div>
                                  </div>
                                </div>
                            </div>
                    </div>
                    <div v-if="tab.id==7">
                      <div>
                                <div class="border-b border-lightgrey">
                                    <div class="flex justify-between mt-2">
                                        <div class="my-1.5 header">Control Result</div>
                                        <div><button @click="showpopupOnAddForResult('addresult')" :class="conditionForResultBtn() || (!presentTaskObject.kpis && (Object.keys(presentTaskObject).includes('controlResults') && presentTaskObject.controlResults?.length != 0) || presentTaskObject.reviewer != userInfo._id || presentTaskObject?.controlResults?.length==1) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center'" >Add Result</button></div>                                  
                                    </div>
                                </div>
                                  <!-- contorlResults -->
                                  <div>
                                    
                                      <div v-if="controlResultsForCompliance.length != 0">
                                        <div v-for="(obj, index) in controlResultsForCompliance" :key="index">
                                          
                                          <div class="flex flex-row mt-5">
                                                <div class="border-l border-t border-b p-2 header w-23  border-lightgrey rounded-tl-md">Control ID </div>
                                                <!-- <div class="border-l border-b p-2 header w-23 border-lightgrey">Compliant (A)</div>  -->
                                                <div class="border-l border-t border-b  border-lightgrey text-xs flex items-center w-27 p-2 header">{{ presentTaskObject.clientUniqueId != undefined ? presentTaskObject.clientUniqueId : 'N/A' }}</div>
                                          <!-- </div>
                                          <div class="flex flex-row"> -->
                                              <div class=" border-l border-t border-b p-2 header w-23 border-lightgrey">Risk Severity </div> 
                                                <div class="border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md">
                                              <!-- <div class="border-r border-b border-l border-lightgrey w-77 p-2"> -->
                                              <div v-if="obj.severity === 'N/A'" class="text-xs">N/A</div>
                                              <div v-else class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(obj.severity)">
                                                <div :class="colorRiskText(obj.severity)">
                                                  {{getSeverityLabel(obj.severity)}}
                                                </div>
                                              </div>
                                            </div>
                                              
                                              <!-- <div class="border-l border-b p-2 header w-23 border-lightgrey">Population (B)</div>  -->
                                              <!-- <div  class="border-r border-b border-l border-lightgrey w-27 p-2">{{ obj.totalPopulation }}</div> -->
                                          </div>
                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey ">Title</div> 
                                              <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center">{{ presentTaskObject.controlTitle }}</div>
                                          </div>


                                          
                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey">Population </div> 
                                              <div  class="border-b border-l text-xs flex items-center border-lightgrey w-27 p-2">{{ obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation }}</div>
                                                <div class="border-l border-b p-2 header w-23 border-lightgrey">Compliant </div> 
                                                <div class="border-r border-b border-l border-lightgrey text-xs flex items-center w-27 p-2">{{ obj.actualOutput == null || obj.actualOutput === '' ? 'N/A' : obj.actualOutput }}</div>
                                          </div>

                                          <div class="flex flex-row" v-if="obj.resultfor == 1">
                                            <div class="border-l border-b p-2 header w-23 border-lightgrey ">Performance Analysis</div> 
                                            <div  class="border-l border-r border-b header border-lightgrey w-77 p-2 h-14">
                                              <div v-if="obj.controlResultValue == null || obj.controlResultValue === ''" class="text-sm w-full h-[2.5rem] flex items-center justify-center">N/A</div>
                                              <div v-else class="ml-2 mr-2">

                                                  <div class="progress-container">
                                                    <div class="progress-bar" :style="{ width: `${obj.controlResultValue}%` }" :class="getPerformanceBg(obj.controlResultValue)">
                                                    </div>
                                                  </div>
                                                  <div class="progress-indicator-count">
                                                    <p class="indicator mt-1" v-if="obj.controlResultValue >= 50" :style="{left: `calc(${obj.controlResultValue}% - 20px)`}">{{ obj.controlResultValue }}%</p>
                                                    <p class="indicator mt-1" v-else :style="{left: `calc(${obj.controlResultValue}%)`}">{{ obj.controlResultValue }}%</p>
                                                  </div>
                                                  </div>
                                                </div>
                                            </div>


                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">Comments</div> 
                                              <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center rounded-br-md">{{ obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments }}</div>
                                          </div>
                                          </div>
                                        </div> 
                                        <div v-else-if="controlResultsForCompliance.length <= 0">
                                          <div>
                                            <div class="flex flex-row mt-5">
                                                <div class="border-l border-t border-b p-2 header w-23  border-lightgrey rounded-tl-md">Control ID </div>
                                                <div class="border-l border-t border-b  border-lightgrey text-xs flex items-center w-27 p-2 header">{{ presentTaskObject.clientUniqueId != undefined ? presentTaskObject.clientUniqueId : 'N/A' }}</div>
                                                <div class=" border-l border-t border-b p-2 header w-23 border-lightgrey">Risk Severity </div> 
                                                <div class="border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md"></div>
                                              
                                              <!-- <div class="border-l border-b p-2 header w-23 border-lightgrey">Population (B)</div>  -->
                                              <!-- <div  class="border-r border-b border-l border-lightgrey w-27 p-2">{{ obj.totalPopulation }}</div> -->
                                          </div>

                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey">Title</div> 
                                              <div class="border-b border-l  border-r border-lightgrey w-77 p-2">
                                              {{ presentTaskObject.controlTitle }}
                                              </div>
                                              
                                          </div>
                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey">Population </div> 
                                              <div  class="border-b border-l border-lightgrey w-27 p-2"></div>
                                                <div class="border-l border-b p-2 header w-23 border-lightgrey">Compliant </div> 
                                                <div class="border-r border-b border-l border-lightgrey w-27 p-2"></div>
                                          </div>

                                          <div class="flex flex-row">
                                            <div class="border-l border-b p-2 header w-23 border-lightgrey ">Performance Analysis</div> 
                                            <div  class="border-l border-r border-b header border-lightgrey w-77 p-2 h-14">
                                              <!-- <div class="ml-2 mr-2">
                                                <div class="progress-container">
                                                  <div class="progress-bar100" v-if="controlProgress >= 50" :style="{ '--progress100': controlProgress + '%' }">
                                                  </div>
                                                  <div class="progress-bar" v-else :style="{ '--progress': controlProgress + '%' }">
                                                  </div>
                                                </div>
                                                <div>
                                                  <div class="progress-indicator-container">
                                                    <span class="indicator" v-if="controlProgress >= 50" :style="{left: `calc(${controlProgress}% - 20px)`}">{{ controlProgress }}%</span>
                                                    <span class="indicator" v-else :style="{left: `calc(${controlProgress}%)`}">{{ controlProgress }}%</span>
                                                  </div>
                                                </div>
                                              </div> -->
                                              <div class="ml-2 mr-2">
                                                  <div class="progress-container">
                                                    <!-- <div class="progress-bar100" v-if="controlProgress >= 50" :style="{ '--progress100': controlProgress + '%' }">
                                                    </div> -->
                                                    <div class="progress-bar">
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <!-- <div class="progress-bar100" v-if="controlProgress >= 50" :style="{ '--progress100': controlProgress + '%' }">
                                                    </div>
                                                    <div class="progress-bar" v-else :style="{ '--progress': controlProgress + '%' }">
                                                    </div> -->
                                                    <div class="progress-indicator-count">
                                                      <!-- <span class="indicator" v-if="controlProgress >= 50" :style="{left: `calc(${controlProgress}% - 20px)`}">{{ controlProgress }}%</span> -->
                                                      <p class="indicator" :style="{left: `calc(${0}%)`}">{{ 0 }}%</p>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                          </div>

                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">Comments</div> 
                                              <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs rounded-br-md"></div>
                                          </div>
                                          </div>
                                          </div>
                                    </div>
                                        <!-- Kpiresults -->

                                        <div class="border-b mt-3 border-lightgrey" v-if="presentTaskObject.kpis">
                                          <div class="flex justify-between mt-2">
                                              <div class="my-1.5 header">KPI Result</div>
                                              <div><button @click="showpopupOnAddForResult('addkpi')" :class="conditionForResultBtn() || (!presentTaskObject.kpis && (Object.keys(presentTaskObject).includes('controlResults') && presentTaskObject.controlResults.length != 0) || presentTaskObject.reviewer != userInfo._id)||(resultArray.length==0)||((presentTaskObject.results)?.length == presentTaskObject.kpis.length)? 'btndisabled pointer-events-none': 'filterButton flex justify-center taskEditButtons'">Add Result</button></div>
                                          </div>
                                        </div>
                                      <div v-if="resultsForCompliance.length != 0">
                                        <div v-for="(obj, index) in presentTaskObject.results" :key="index">
                                          <!-- <div v-for="i in presentTaskObject.kpis" :key="i._id"> -->
                                            <div class="flex flex-row mt-5">
                                                <div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">KPI ID</div> 
                                                  <div v-if="obj.controlorKpi != ''" class="border-t border-r border-b border-l border-lightgrey w-27 p-2"> {{ presentTaskObject.kpis.find((kpi)=>kpi._id == obj.controlorKpi)?.kpi_id ||'N/A'}}</div>
                                                  <div v-else class="border-t border-r border-b border-l border-lightgrey w-27 p-2"></div>
                                                <!-- <div class="flex"> -->
                                                  <div  class="border-t  border-b p-2 header w-23 border-lightgrey">Risk Severity</div> 
                                                  <div class="border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md">
                                                  <div class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(obj.severity)">
                                                    <div :class="colorRiskText(obj.severity)">
                                                      {{getSeverityLabel(obj.severity)}}
                                                    </div>
                                                  </div>
                                                </div>
                                                <!-- </div> -->
                                            </div>

                                          <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey ">KPI Name</div> 
                                              <!-- <div v-if="obj.controlorKpi != ''" class="border-r border-b border-l border-lightgrey w-27 p-2">{{ presentTaskObject.kpis.find((kpi)=>{return kpi._id == obj.controlorKpi}).description }}</div> -->
                                              <div  class="border-r border-b border-l border-lightgrey w-77 p-2 ">{{ presentTaskObject.kpis.find((kpi)=>kpi._id == obj.controlorKpi)?.description }}</div>
                                            </div>

                                            <div class="flex flex-row">
                                                  <div class="border-l  p-2 header w-23 border-lightgrey">Compliant </div> 
                                                  <div class=" border-l border-lightgrey w-27 p-2">{{ obj.actualOutput }}</div>
                                            <!-- </div>
                                            <div class="flex flex-row"> -->
                                                <div class="border-l  p-2 header w-23 border-lightgrey">Population </div> 
                                              <div  class="border-r  border-l border-lightgrey w-27 p-2">{{ obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation }}</div>
                                            </div>

                                            <div class="flex flex-row">
                                              <div class="border-t border-l border-b p-2 header w-23 border-lightgrey">Performance Analysis</div> 
                                              <div  class="border header border-lightgrey w-77 p-2 h-14">
                                                <div class="ml-2 mr-2">
                                                  <div class="progress-container">
                                                    <!-- <div class="progress-bar100" v-if="obj.kpiProgress >= 50" :style="{ '--progress100': obj.kpiProgress + '%' }">
                                                    </div> -->
                                                    <div class="progress-bar" :style="{ width: `${obj.kpiProgress}%` }" :class="getPerformanceBg(obj.kpiProgress)">
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div class="progress-indicator-count">
                                                      <p class="indicator" v-if="obj.kpiProgress >= 50" :style="{left: `calc(${obj.kpiProgress}% - 20px)`}">{{ obj.kpiProgress }}%</p>
                                                      <p class="indicator" v-else :style="{left: `calc(${obj.kpiProgress}%)`}">{{ obj.kpiProgress }}%</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="flex flex-row">
                                              <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">Comments</div> 
                                              <div  class="border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md">{{ obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments }}</div>
                                            </div>
                                        <!-- </div> -->
                                        </div>
                                      </div>
                                  <div v-else-if="resultsForCompliance.length == 0">
                                    <!-- <div v-for="i in kpisArray"> gffggsf -->
                                      <div v-for="i in presentTaskObject.kpis" :key="i">
                                        <div v-if="(presentTaskObject.kpis != null || presentTaskObject.kpis != undefined) && (presentTaskObject.kpis.length > 0)">
                                          <div class="flex flex-row mt-5">
                                              <div class="border-t border-l p-2 header w-23 border-lightgrey rounded-tl-md">KPI ID</div> 
                                              <div class="border-t border-l border-lightgrey w-27 p-2"></div>
                                            <!-- </div>
                                            <div class="flex flex-row"> -->
                                              <div class="border-t border-l p-2 header w-23 border-lightgrey">Risk Severity</div> 
                                              <div  class="border-t border-r border-l border-lightgrey w-27 p-2 rounded-tr-md"></div>
                                              <!-- </div> -->
                                          </div>
                                          <div class="flex flex-row">
                                            <div class="border-t border-l border-b p-2 header w-23 border-lightgrey">KPI Name</div> 
                                            <div  class="border-t border-r border-b border-l border-lightgrey w-77 p-2"></div>
                                          </div>
                                          <div class="flex flex-row">
                                            <div class="border-l p-2 header w-23 border-lightgrey">Compliant </div> 
                                            <div class="border-l border-lightgrey w-27 p-2"></div>
                                          <!-- </div>
                                          <div class="flex flex-row"> -->
                                            <div class="border-l p-2 header w-23 border-lightgrey">Population </div> 
                                            <div  class="border-r border-l border-lightgrey w-27 p-2"></div>
                                          </div>
                                            <div class="flex flex-row h-14">
                                            <div class="border-t border-l border-b p-2 header w-23 border-lightgrey">Performance Analysis</div> 
                                            <div  class="border header border-lightgrey w-77 p-2 h-14">
                                              <div class="ml-2 mr-2">
                                                <div class="progress-container">
                                                  <!-- <div class="progress-bar100" v-if="kpiProgress >= 50" :style="{ '--progress100': 0 + '%' }">
                                                  </div> -->
                                                  <div class="progress-bar">
                                                  </div>
                                                </div>
                                                <div>
                                                  <div class="progress-indicator-count">
                                                    <p class="indicator" :style="{left: `calc(${0}%)`}">{{ 0 }}%</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="flex flex-row">
                                            <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">Comments</div> 
                                            <div  class="border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md"></div>
                                          </div>
                                        </div> 
                                      </div>
                                  <!-- </div> -->
                                </div>

                                <div v-if="presentTaskObject.results">
                                  <div v-if="presentTaskObject.kpis.length != presentTaskObject.results.length">
                                    <div v-for="index in (presentTaskObject.kpis.length - presentTaskObject.results.length)" :key="index">
                                      <div class="flex flex-row mt-5">
                                                <div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">KPI ID</div> 
                                                
                                                  <div class="border-t border-r border-b border-l border-lightgrey w-27 p-2"></div>
                                                <!-- <div class="flex"> -->
                                                  <div class="border-t border-b p-2 header w-23 border-lightgrey">Risk Severity</div> 
                                                  <div class="border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md">
                                                  </div>
                                                <!-- </div> -->
                                            </div>
                                      <div class="flex flex-row">
                                        <div class="border-l border-b p-2 header w-23 border-lightgrey">KPI Name</div> 
                                        <div  class="border-r border-b border-l border-lightgrey w-77 p-2"></div>
                                      </div>
                                      <div class="flex flex-row">
                                        <div class="border-l p-2 header w-23 border-lightgrey">Compliant </div> 
                                        <div class="border-l border-lightgrey w-27 p-2"></div>
                                      <!-- </div>
                                      <div class="flex flex-row"> -->
                                        <div class="border-l p-2 header w-23 border-lightgrey">Population </div> 
                                        <div  class="border-r border-l border-lightgrey w-27 p-2"></div>
                                      </div>
                                      <div class="flex flex-row">
                                      <div class="border-t border-l border-b p-2 header w-23 border-lightgrey">Performance Analysis</div> 
                                      <div class="border header border-lightgrey w-77 p-2 h-14">
                                        <div class="ml-2 mr-2">
                                          <div class="progress-container">
                                            <div class="progress-bar">
                                            </div>
                                          </div>
                                          
                                            <div class="progress-indicator-count">
                                              <p class="indicator" :style="{left: `calc(${0}%)`}">{{ 0 }}%</p>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                      <div class="flex flex-row">
                                        <div class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md">Comments</div> 
                                        <div  class="border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            <!-- </div> -->
                            <!-- </div> -->
                                <!-- </div> -->
                                <!-- </div> -->
                                <!-- </div> -->
                            <!-- </div> -->

                          </div>
                    </div>
                    <div v-if="tab.id==8">
                      <div>
                                <div class="border-b border-lightgrey flex justify-between mt-2">
                                    <div><p class="my-1.5 header">Work History</p></div>
                                    <div>
                                        <div class="buttonposition flex justify-center items-center">
                                            <div class="buttonposition flex justify-center items-center">
                                                <button class="filterButton flex " v-if="newHistory" @click="sortWorkLog()" :class="Object.keys(this.workLogObject).includes('taskHistory') && this.workLogObject.taskHistory.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none'">
                                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                                    Oldest
                                                </button>
                                                <button class="filterButton flex" v-if="!newHistory" @click="sortWorkLog()">
                                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                                    Newest
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-for="work in workLogObject.taskHistory" :key="work" class="bg-white py-4 border-lightgrey border-b w-full">
                                    <div class="flex">
                                        <div v-if="Object.keys(work).includes('createdBy')" class="initials cursor-pointer">
                                            {{ extractInitials(getPersonName(work.createdBy)) }}
                                        </div>
                                        <div v-if="Object.keys(work).includes('updatedBy')" class="initials cursor-pointer">
                                            {{ extractInitials(getPersonName(work.updatedBy)) }}
                                        </div>
                                        <div class="logContainer w-93">
                                            <div class="flex pt-1.5">
                                                <p v-if="Object.keys(work).includes('createdBy')" class="font-semibold cursor-pointer text-xs">
                                                    {{ getPersonName(work.createdBy) }}
                                                </p>
                                                <p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold cursor-pointer text-xs">
                                                    {{ getPersonName(work.updatedBy) }}
                                                </p>
                                                <p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Task on' }}</p>
                                                <p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Task on' }}</p>
                                                <p v-if="Object.keys(work).includes('createdAt')" class="font-semibold cursor-pointer text-xs">{{ formatTime(work.createdAt) }}</p>
                                                <p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold cursor-pointer text-xs">{{ formatTime(work.updatedAt) }}</p>
                                            </div>
                                            <div class="mt-4" v-if="work.additionalInfo != null && Object.keys(work).includes('additionalInfo')">
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('comment')">
                                                    <p class="font-semibold text-xs w-12">{{ 'Comment:' }}</p>



                                                    <!-- <p class="text-xs w-88 ml-4">{{ work.additionalInfo.comment }}</p> -->

                                                    <div class="text-xs w-88 ml-4">
                                                      <safeHtml :content="work.additionalInfo.comment"/>
                                                    </div>





                                                </div>
                                                <div class="flex flex-wrap items-center" v-if="Object.keys(work.additionalInfo).includes('actualOutput')">
                                                  <p class="font-semibold cursor-pointer text-xs pr-2">{{'Added the Result -'}}</p>
                                                    <p class="font-semibold cursor-pointer text-xs">{{ 'Compliant (A) :' }}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.actualOutput }}</p>
                                                    <p class="font-semibold cursor-pointer text-xs">{{ 'Population (B) :' }}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.totalPopulation }}</p>
                                                    <template v-if="work.additionalInfo.riskSeverity != null && work.additionalInfo.riskSeverity !== ''">
                                                      <p class="font-semibold cursor-pointer text-xs">{{ 'Risk Severity :' }}</p>
                                                      <div class="mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(work.additionalInfo.riskSeverity)">
                                                        <div :class="colorRiskText(work.additionalInfo.riskSeverity)">
                                                          {{ getSeverityLabel(work.additionalInfo.riskSeverity) }}
                                                        </div>
                                                      </div>
                                                    </template>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('updatedActualOutput')">
                                                  <p class="font-semibold cursor-pointer text-xs pr-2">{{'Updated the Result -'}}</p>
                                                  <template v-if="!(work.additionalInfo.changes && work.additionalInfo.changes.length)">
                                                    <p class="font-semibold cursor-pointer text-xs">{{ 'Compliant (A) :' }}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.updatedActualOutput }}</p>
                                                    <p class="font-semibold cursor-pointer text-xs">{{ 'Population (B) :' }}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.totalPopulation }}</p>
                                                  </template>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('findingId')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Added the finding -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.findingId }}</p>
                                                </div>
                                                <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('findingRelatedToLabel')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Related To -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.findingRelatedToLabel }}</p>
                                                </div>
                                                <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('controlTitle') && work.additionalInfo.controlTitle">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Control -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.controlTitle }}</p>
                                                </div>
                                                <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('kpiName') && work.additionalInfo.kpiName">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'KPI -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.kpiName }}</p>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('updatedFindingId')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Updated the finding -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.updatedFindingId }}</p>
                                                </div>
                                                <div class="flex mt-2" v-for="file in (work.additionalInfo.addedAttachments || [])" :key="'added-' + file">
                                                    <p class="font-semibold text-xs">{{'Attached -'}}</p>
                                                    <p class="mx-2 text-xs">{{ file }}</p>
                                                </div>
                                                <div class="flex mt-2" v-for="file in (work.additionalInfo.removedAttachments || [])" :key="'removed-' + file">
                                                    <p class="font-semibold text-xs">{{'Removed the attachment -'}}</p>
                                                    <p class="mx-2 text-xs">{{ file }}</p>
                                                </div>
                                                <div class="flex items-center mt-2" v-for="change in (work.additionalInfo.changes || [])" :key="change.field">
                                                    <p class="font-semibold text-xs shrink-0 whitespace-nowrap">{{ change.field }}</p>
                                                    <template v-if="change.field === 'Risk Severity'">
                                                      <div class="mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(change.previous)">
                                                        <div :class="colorRiskText(change.previous)">
                                                          {{ getSeverityLabel(change.previous) }}
                                                        </div>
                                                      </div>
                                                      <div class="mx-2 flex items-center shrink-0"><img src="@/assets/arrowRight.svg" class="shrink-0"/></div>
                                                      <div class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(change.updated)">
                                                        <div :class="colorRiskText(change.updated)">
                                                          {{ getSeverityLabel(change.updated) }}
                                                        </div>
                                                      </div>
                                                    </template>
                                                    <template v-else>
                                                      <p class="mx-2 text-xs min-w-0 break-words">{{ formatResultHistoryValue(change.field, change.previous) }}</p>
                                                      <div class="mx-2 flex items-center shrink-0"><img src="@/assets/arrowRight.svg" class="shrink-0"/></div>
                                                      <p class="text-xs min-w-0 break-words">{{ formatResultHistoryValue(change.field, change.updated) }}</p>
                                                    </template>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Uploaded the Evidence -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
                                                </div>
                                                <div class="flex" v-if="work.additionalInfo.removed">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Deleted the Evidence -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Linked the Evidence -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles }}</p>
                                                </div>
                                                <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Evidence Date -'}}</p>
                                                    <p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates }}</p>
                                                </div>
                                                <div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
                                                    <p class="font-semibold cursor-pointer text-xs">{{'Assigned the task to -'}}</p>
                                                    <p class="mx-2 text-xs">{{ getPersonName(work.additionalInfo.assignee) }}</p>
                                                </div>
                                                <div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
                                                    <div>
                                                        <p class="font-semibold cursor-pointer text-xs">{{'Updated The Status :'}}</p>
                                                    </div>
                                                    <div class="flex ml-4">
                                                        <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorComplianceBg(work.additionalInfo.previousStatus)">
                                                            <div :class="colorComplianceText(work.additionalInfo.previousStatus)">
                                                                {{ getStatusLabel(work.additionalInfo.previousStatus) }}
                                                            </div>
                                                        </div>
                                                        <div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
                                                        <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorComplianceBg(work.additionalInfo.updatedStatus)">
                                                            <div :class="colorComplianceText(work.additionalInfo.updatedStatus)">
                                                                {{ getStatusLabel(work.additionalInfo.updatedStatus) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                  </div>
                    

                </div>

              </TabPanel>
            </TabPanels>
            </Tabs>
              <div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
                  <div class="m-3">
                      <div class="pb-2 border-b border-lightgrey"><h1>Task Details</h1></div>
                      <div v-if="tabDataLoading == true">
                      <div class="flex items-center justify-center w-full h-16 skeleton">
                        <dots-loader/>
                      </div>
                    </div>
                      <div v-else class="pt-2 overflow-y-scroll thirtyWidthToggle">
                          <div>
                              <label class="controllabel">Task Status</label>
                               <div v-if="TaskDetailsDropDown.taskStatus == 10418" class="bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 mb-3">
                                   <div class="bg-error textColorWhite">{{'Terminated'}}</div>
                                </div>
                                <div v-else>
                                    <!-- <select class="custom-select inputboxstyling1 cursor-pointer mt-2" :disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417" v-model="TaskDetailsDropDown.taskStatus" :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
                                      <option value="" selected disabled hidden>Please select one</option>
                                      <option v-for="i in this.taskStatusData" :value="i.id" :key="i" :disabled="(i.id === 10403 || i.id === 10417) && this.teamReviewerValue != this.userInfo._id" :class="(i.id === 10403 || i.id === 10417) && this.teamReviewerValue != this.userInfo._id? 'taskStatusOptionsForNotStarted' : 'taskStatusOptions'">
                                          {{ i.status }}
                                      </option>
                                  </select> -->
                                   <Select
                                      v-model="TaskDetailsDropDown.taskStatus"
                                      :options="taskStatusData"
                                      appendTo="body"
                                      @change="onTaskStatusChange"
                                      optionLabel="status"
                                      optionValue="id"
                                      class="w-full statusBorder mt-2"
                                      :class="changeBackground()"
                                      :disabled="(TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417)" 
                                      :optionDisabled="(option) =>
                                        (option.id === 10403 || option.id === 10417) &&
                                        teamReviewerValue !== userInfo._id &&
                                        option.id !== TaskDetailsDropDown.taskStatus"
                                  />
                                </div>
                          </div>
                          <div class="mt-3">
                             <!-- || presentTaskObject.teamOwner != userInfo._id -->
                              <label class="controllabel">Assignee</label>
                              <div v-if="newTeamLeader==''">N/A</div>
                              <div v-if="newTeamLeader.value != userInfo._id  && presentTaskObject.teamOwner != userInfo._id || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418">
                                <p class="mt-2">{{ newTeamLeader.label }}</p>
                              </div>
                              <div v-else>
                               <AutoComplete 
                                v-model="presentComplianceObject.teamLeader"
                                :suggestions="TeamOwnerOptions"
                                @complete="asyncFind1"
                                @item-select="updateTaskForTeamLeader(presentComplianceObject.teamLeader)"
                                optionLabel="label"
                                optionValue="value"
                                :forceSelection="true"
                                placeholder="TeamLeader"
                                class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                                />
                              </div>
                          </div>
                          <div class="mt-3">
                              <label class="controllabel">Reviewer</label><br>
                              <p v-if="presentTaskObject.reviewer != undefined || presentTaskObject.reviewer != null"  class="mt-2 text-sm">{{ getPersonName(presentTaskObject.reviewer) }}</p>
                              <p class="mt-2 text-sm" v-else>N/A</p>
                              <!-- <input class="inputboxstyling cursor-pointer" type="text" placeholder="Name of the Reviewer" /> -->
                          </div>
                          <div class="mt-3">
                              <label class="controllabel">Team Representative</label><br>
                              <p v-if="presentTaskObject.teamOwner != undefined || presentTaskObject.teamOwner != null"  class="mt-2 text-sm">{{ getPersonName(presentTaskObject.teamOwner) }}</p>
                              <p class="mt-2 text-sm" v-else>N/A</p>
                              <!-- <input class="inputboxstyling cursor-pointer" type="text" placeholder="Default will be Team Owner" /> -->
                          </div>
                          <div class="mt-3">
                              <label class="controllabel">Team</label><br>
                              <p v-if="presentTaskObject.department != undefined || presentTaskObject.department != null" class="mt-2 text-sm">{{ getTeamName(presentTaskObject.department) }}</p>
                              <p class="mt-2 text-sm" v-else>N/A</p>
                                  <!-- {{ getPersonName(presentTaskObject.department) }} -->
                          </div>
                          <div class="mt-3">
                              <label class="controllabel">Location</label><br>
                              <!-- <p v-if="(presentTaskObject.entity && presentTaskObject.entity != undefined && presentTaskObject.entity != null)" class="mt-2 text-sm">{{ getLocationName(presentTaskObject.entity,presentTaskObject.entitytypecodeid) }}</p>
                              <p class="mt-2 text-sm" v-else-if= "presentTaskObject.entitytypecodeid == 20301">Global</p>
                              <p class="mt-2 text-sm" v-else>N/A</p> -->
                              <!-- <div class="mt-2 text-sm">{{ getDeptEntity(presentTaskObject.department) }}</div> -->
                              <!-- <div v-if="presentTaskObject.department != undefined || presentTaskObject.department != null" class="mt-2 text-sm">{{ getDeptEntity(presentTaskObject.department) }}</div>
                              <p class="mt-2 text-sm" v-else>N/A</p> -->
                              <div v-if="Object.keys(presentTaskObject).includes('location') && (presentTaskObject.location!=undefined || presentTaskObject.location!=null)" class="mt-2">{{ presentTaskObject.location }}</div>
                              <div v-else-if="Object.keys(presentTaskObject).includes('location') && !Object.keys(presentTaskObject).includes('entity') && presentTaskObject.location != '' && presentTaskObject.location != null && presentTaskObject.location != undefined" class="mt-2 text-sm">{{ presentTaskObject.location }}</div>
                              <div v-else-if="Object.keys(presentTaskObject).includes('entity') && presentTaskObject.entity != '' && presentTaskObject.entity != null && presentTaskObject.entity != undefined" class="mt-2">{{ getEntity(presentTaskObject.entity) }}</div>
                              <div v-else-if="Object.keys(presentTaskObject).includes('location') && (presentTaskObject.location=='' || presentTaskObject.location==null)&& presentTaskObject.department!=''">{{getLocationNameForSystem(presentTaskObject.department)}}</div>
                              <div v-else-if='(presentTaskObject.entity ==""||presentTaskObject.entity !=null) && presentTaskObject.location!=null '>
                                <div v-for="val in users" :key='val._id'>
                                  <div v-if="val._id==presentTaskObject.department && val.entityType==20301">{{'Global'}}</div>
                                </div>
                              </div>
                              <p class="mt-2 text-sm" v-else>N/A</p>
                          </div>
                          <div class="mt-3">
                              <label class="controllabel mb-2">Tier</label><br>
                              <div>{{ getTargetDetails(presentTaskObject).tier }}</div>
                            </div>
                            <div class="mt-3">
                              <label class="controllabel mb-2">Scope</label><br>
                              <div v-if="presentTaskObject.tierTitle != '' && presentTaskObject.tierTitle != null && presentTaskObject.tierTitle != undefined">{{ presentTaskObject.tierTitle }}</div>
                              <div v-else>N/A</div>
                            </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <popup v-if="showPopUp" :popUp="showPopUp">
        <template v-slot:header>
            <div class="flex items-center justify-between m-4 rounded">
                <h1>Findings</h1>
                <button class="float-right text-3xl" @click="onCancelButtonAddPopUp()">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
  <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">

      <fieldset>
          <div class="statuscontainer popupbodycontainer">
              <div class="formcontainer flex flex-col">
                <div class="row flex flex-row w-full upperspacing">
                  <div class="row flex flex-row w-full">
                    <div class="w-1/2 pr-2">
                    <label class="controllabel">Finding Id</label>
                    <!-- <input type="text" v-model="findingsObject.findingId" disabled class="inputboxstyling mt-2"/> -->
                    <div class="mt-2 text-sm inputboxstyling">{{ findingsObject.findingId?.toUpperCase() }}</div>
                    <!-- <div v-if="v$.findingsObject.findingId.$error" class="text-red-500">
                      <div class="error-text" v-if="v$.findingsObject.findingId.required.$invalid">Required</div>
                    </div> -->
                    </div>
                    <div class="w-1/2">
                    <label class="controllabel">Evidence</label>
                    <!-- <textarea v-model="findingsObject.findingEvidence" class="inputboxstyling resize-none" placeholder="Finding related to Evidence" :class="{ 'is-invalid': v$.findingsObject.findingEvidence.$error }"></textarea> -->
                    <!-- <multiselect
                      v-model="findingsObject.findingEvidence"
                      :options="evidenceArray"
                      :show-labels="false"
                      :multiple="false"
                      :hide-selected="true"
                      open-direction="bottom"
                      :searchable="true"
                      :hideArrow="false"
                      placeholder="Evidences"
                      class=" userSelect custom-multiselect mt-2"
                      :class="{'is-invalidmultiselect': v$.findingsObject.findingEvidence.$error}"
                    >
                      <template v-slot:noResult>
                        <span class="text-xs">No Evidences Found</span>
                      </template>
                    </multiselect>
                  <div v-if="v$.findingsObject.findingEvidence.$error" class="text-red-500">
                    <div class="error-text" v-if="v$.findingsObject.findingEvidence.required.$invalid">Required</div>
                  </div> -->
                    <AutoComplete
                      v-model="findingsObject.findingEvidence"
                      :suggestions="filteredOptions"
                      @complete="asyncFind"
                      :placeholder="'Evidences'"
                      class="p-inputtext-sm systemsstyling custom-multiselect userSelect mt-2"
                      :class=" {'p-invalid': v$.findingsObject.findingEvidence.$error }"
                    />
                     
                    <!-- Validation Error -->
                    <div v-if="v$.findingsObject.findingEvidence.$error" class="text-red-500 text-xs mt-1">
                      <div v-if="v$.findingsObject.findingEvidence.required.$invalid">Required</div>
                    </div>

                </div>
                    <!-- <div class="w-1/2 pr-2">
                    <label class="controllabel">Category</label>
                    <select class="inputboxstyling cursor-pointer" v-model="findingsObject.findingCategory" :class="{ 'is-invalid': v$.findingsObject.findingCategory.$error }">
                      <option value="" selected disabled hidden>Please select one</option>
                        <option v-for="i in findingCategoryData" :value="i.id" :key="i.id">
                              {{ i.value }}
                        </option>
                    </select>
                    <div v-if="v$.findingsObject.findingCategory.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.findingsObject.findingCategory.required.$invalid">Required</div>
                    </div>
                    </div> -->
                  </div>
                </div>
                <div class="row flex flex-row w-full upperspacing">
                  <div class="w-1/2 pr-2">
                    <label class="controllabel">Related To</label>
                    <Select
                      v-model="findingsObject.findingRelatedTo"
                      :options="findingRelatedToOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Please select one"
                      appendTo="self"
                      class="w-full mt-2"
                      :class="{ 'is-invalid': v$.findingsObject.findingRelatedTo.$error }"
                      @change="onFindingRelatedToChange"
                    />
                    <div v-if="v$.findingsObject.findingRelatedTo.$error" class="text-red-500 text-xs mt-1">
                      <div v-if="v$.findingsObject.findingRelatedTo.required.$invalid">Required</div>
                    </div>
                  </div>
                  <div class="w-1/2 min-w-0" v-if="Number(findingsObject.findingRelatedTo) === 1">
                    <label class="controllabel">Control</label>
                    <Select
                      v-model="findingsObject.control_id"
                      :options="taskMappedControlOptions"
                      optionLabel="label"
                      optionValue="_id"
                      placeholder="No control mapped to this task"
                      appendTo="self"
                      class="w-full mt-2"
                      :class="{ 'is-invalid': v$.findingsObject.control_id.$error }"
                      :disabled="taskMappedControlOptions.length <= 1"
                    />
                    <div v-if="v$.findingsObject.control_id.$error" class="text-red-500 text-xs mt-1">
                      <div v-if="v$.findingsObject.control_id.required.$invalid">No control mapped to this task</div>
                    </div>
                  </div>
                  <div class="w-1/2 min-w-0" v-else-if="Number(findingsObject.findingRelatedTo) === 2">
                    <label class="controllabel">KPI</label>
                    <Select
                      v-model="findingsObject.kpi_id"
                      :options="presentTaskObject.kpis || []"
                      optionLabel="description"
                      optionValue="_id"
                      placeholder="Please select one"
                      appendTo="self"
                      class="w-full mt-2 kpi-title-select"
                      :class="{ 'is-invalid': v$.findingsObject.kpi_id.$error }"
                    />
                    <div v-if="v$.findingsObject.kpi_id.$error" class="text-red-500 text-xs mt-1">
                      <div v-if="v$.findingsObject.kpi_id.required.$invalid">Required</div>
                    </div>
                  </div>
                </div>
                <div class="w-full upperspacing">
                      <label class="controllabel">Finding</label>
                      <textarea v-model.trim="findingsObject.finding" class="inputboxstyling mt-2 resize-none" placeholder="Finding" rows="3" @input="v$.findingsObject.finding.$touch()"  :class="{ 'is-invalid': v$.findingsObject.finding.$error }"></textarea>
                      <div v-if="v$.findingsObject.finding.$error" class="text-red-500">
                        <div class="error-text" v-if="v$.findingsObject.finding.required.$invalid">Required</div>
                        <div v-else-if="v$.findingsObject.finding.required && v$.findingsObject.finding.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                      </div>
                  </div>      
              </div>
          </div>
          
      </fieldset>
    </div>
    <div>
        <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
          <button class="mr-1.5" :class="JSON.stringify(findingsObject) !== JSON.stringify(findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtn()">Reset</button>
          <button class="" :class="JSON.stringify(findingsObject) !== JSON.stringify(findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButtonForFinding" @click="addFindingButton()">Save</button>
        </div>
    </div>
    </div>
    </popup>
    <popup v-if="showPopUpForResult" :popUp="showPopUpForResult">
    <template v-slot:header>
          <div class="flex items-center justify-between m-4 rounded">
              <h1>Result</h1>
              <button class="float-right text-3xl" @click="onCancelButtonAddPopUpForResult()">
                  <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
              </button>
          </div>
      </template>
      <div class='flex flex-col h-full'>
				<div class="flex-1 overflow-auto">
          <fieldset>
              <div class="statuscontainer popupbodycontainer">
                <div class="formcontainer flex flex-col">
                  <div class="row flex flex-row w-full">
                    <div class="row flex flex-row w-full upperspacing">
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Population</label>
                        <input type="number" @input="handlePopulationDecimalValue" v-model.trim="resultObject.totalPopulation" class="inputboxstyling mt-2" placeholder="Total Population" @keyup="isTotalPopulationValid()" :class="{ 'is-invalid': v$.resultObject.totalPopulation.$error || !resultOfPopulation }"/>
                          <div v-if="(v$.resultObject.totalPopulation.$error || !resultOfPopulation)" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.totalPopulation.required.$invalid ">Required</div>
                          <!-- <div class="error-text" v-else-if="!resultOfNegativePopulation && (resultObject.totalPopulation != undefined || resultObject.totalPopulation != null) && (resultObject.totalPopulation < 0)">Value must be non-negative</div> -->
                          <div class="error-text" v-else-if="!resultOfPopulation && !v$.resultObject.totalPopulation.required.$invalid ">Population must be greater than or equal to Compliant</div>
                        </div>
                      </div>
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Complaint</label>
                        <input type="number" @input="handleComplaintDecimalValue" v-model.trim="resultObject.actualOutput" class="inputboxstyling mt-2" placeholder="Actual output" :disabled="!isCompliantInputEnabled" :class="{ 'is-invalid': v$.resultObject.actualOutput.$error, 'disiableState': !isCompliantInputEnabled }"/>
                        <div v-if="v$.resultObject.actualOutput.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.actualOutput.required.$invalid">Required</div>
                          <!-- <div class="error-text" v-if="(resultObject.actualOutput != undefined || resultObject.actualOutput != null) && (resultObject.actualOutput < 0) && !resultOfNegativeOutput">Value must be non-negative</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full">
                    <div class="row flex flex-row w-full upperspacing">
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Risk Severity</label>
                        <Select
                          v-model="resultObject.riskSeverity"
                          :options="dbSeverity"
                          optionLabel="key"
                          optionValue="value"
                          placeholder="Please select one"
                          appendTo="self"
                          class="w-full mt-2"
                          :class="{ 'is-invalid': v$.resultObject.riskSeverity.$error }"
                        />
                        <div v-if="v$.resultObject.riskSeverity.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.riskSeverity.required.$invalid">Required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-full upperspacing">
                    <label class="controllabel">Comments</label>
                      <textarea v-model.trim="resultObject.comments" class="inputboxstyling resize-none mt-2" placeholder="Comments" rows="3" @input="v$.resultObject.comments.$touch()" :class="{ 'is-invalid': v$.resultObject.comments.$error }"></textarea>
                        <div v-if="v$.resultObject.comments.$error" class="text-red-500">
                          <div class="error-text text-xs" v-if="v$.resultObject.comments.required.$invalid">Required</div>
                          <div v-else-if="v$.resultObject.comments.required && v$.resultObject.comments.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                        </div>
                    </div>
                  </div>
                </div>
          </fieldset>
        </div>
        <div>
          <div class="border-b border-solid border-lightgrey mx-5"></div>
          <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
            <button class="mr-1.5" :class="JSON.stringify(resultObject) !== JSON.stringify(resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtnForResult()">Reset</button>
            <button class="" :class="JSON.stringify(resultObject) !== JSON.stringify(resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButtonForResult" @click="addResultButtonForTask(resultObject)">Save</button>
        </div>
      </div>
        </div>
    </popup>
    <popup v-if="showPopUpForKpi" :popUp="showPopUpForKpi">
    <template v-slot:header>
          <div class="flex items-center justify-between m-4 rounded">
              <h1>Result</h1>
              <button class="float-right text-3xl" @click="onCancelButtonAddPopUpForKpi()">
                  <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
              </button>
          </div>
      </template>
      <div class='kpi-result-popup flex flex-col h-full min-w-0 max-w-full'>
				<div class="flex-1 min-w-0 overflow-x-hidden overflow-y-auto">
          <fieldset>
              <div class="statuscontainer popupbodycontainer">
                <div class="formcontainer flex flex-col min-w-0">
                  <div class="row flex flex-row w-full min-w-0 upperspacing">
                    <div class="row flex flex-row w-full min-w-0">
                      <div class="w-full pr-2 min-w-0">
                        <div v-if="presentTaskObject.kpis" class="kpi-title-select-wrap">
                          <label class="controllabel">KPI Title.</label>
                           <!-- <select 
                            class="w-full mt-2 px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                            @click="getKpis()"
                            v-model = resultObject.controlorKpi
                            :class="{ 'is-invalid': v$.resultObject.controlorKpi.$error }"
                            placeholder="Please select one"
                            >
                              <option value="" selected disabled hidden>Please select one</option>
                              <option v-for="i in kpisArray" :value="i._id" :key="i._id">
                                  {{i.description}}
                              </option>
                          </select> -->
                          <Select
                          v-model="resultObject.controlorKpi"
                          :options="kpisArray"
                          @click="getKpis()"
                          optionLabel="description"
                          optionValue="_id"
                          placeholder="Please select one"
                          appendTo="self"
                          class="w-full mt-2 kpi-title-select"
                          :class="{ 'is-invalid': v$.resultObject.controlorKpi.$error }"
                          />
                        </div>
                        <div v-if="v$.resultObject.controlorKpi.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.controlorKpi.required.$invalid">Required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full">
                    <div class="row flex flex-row w-full upperspacing">
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Complaint</label>
                        <input type="number" @input="handleComplaintDecimalValue" v-model.trim="resultObject.actualOutput" class="inputboxstyling mt-2" placeholder="Actual output" :class="{ 'is-invalid': v$.resultObject.actualOutput.$error }"/>
                        <div v-if="v$.resultObject.actualOutput.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.actualOutput.required.$invalid">Required</div>
                          <!-- <div class="error-text" v-if="(resultObject.actualOutput != undefined || resultObject.actualOutput != null) && (resultObject.actualOutput < 0) && !resultOfNegativeOutput">Value must be non-negative</div> -->
                        </div>
                      </div>
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Population</label>
                        <input type="number" @input="handlePopulationDecimalValue" v-model.trim="resultObject.totalPopulation" class="inputboxstyling mt-2" placeholder="Total Population" @keyup="isTotalPopulationValid()" :class="{ 'is-invalid': v$.resultObject.totalPopulation.$error || !resultOfPopulation }"/>
                        <div v-if="v$.resultObject.totalPopulation.$error || !resultOfPopulation" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.totalPopulation.required.$invalid">Required</div>
                          <!-- <div class="error-text" v-else-if="!resultOfNegativePopulation && (resultObject.totalPopulation != undefined || resultObject.totalPopulation != null) && (resultObject.totalPopulation < 0)">Value must be non-negative</div> -->
                          <div class="error-text" v-else-if="!resultOfPopulation && !v$.resultObject.totalPopulation.required.$invalid">Population must be greater than or equal to Compliant</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row flex flex-row w-full">
                    <div class="row flex flex-row w-full upperspacing">
                      <div class="w-1/2 pr-2">
                        <label class="controllabel">Risk Severity</label>
                        <Select
                          v-model="resultObject.riskSeverity"
                          :options="dbSeverity"
                          optionLabel="key"
                          optionValue="value"
                          placeholder="Please select one"
                          appendTo="self"
                          class="w-full mt-2"
                          :class="{ 'is-invalid': v$.resultObject.riskSeverity.$error }"
                        />
                        <div v-if="v$.resultObject.riskSeverity.$error" class="text-red-500">
                          <div class="error-text" v-if="v$.resultObject.riskSeverity.required.$invalid">Required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-full upperspacing">
                    <label class="controllabel">Comments</label>
                      <textarea v-model.trim="resultObject.comments" class="inputboxstyling resize-none mt-2" placeholder="Comments" rows="3" @input="v$.resultObject.comments.$touch()" :class="{ 'is-invalid': v$.resultObject.comments.$error }"></textarea>
                        <div v-if="v$.resultObject.comments.$error" class="text-red-500">
                          <div class="error-text text-xs" v-if="v$.resultObject.comments.required.$invalid">Required</div>
                          <div v-else-if="v$.resultObject.comments.required && v$.resultObject.comments.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                        </div>
                    </div>
                  </div>
                </div>
               
          </fieldset>
        </div>
        <div>
          <div class="border-b border-solid border-lightgrey mx-5"></div>
           <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
              <button class="mr-1.5" :class="JSON.stringify(resultObject) !== JSON.stringify(resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtnForResult()">Reset</button>
              <button class="" :class="JSON.stringify(resultObject) !== JSON.stringify(resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButtonForResult" @click="addResultButtonForTaskKpi(resultObject)">Save</button>
          </div>
        </div>
      </div>
    </popup>
   
    <popup v-if="importpopUp" :popUp="importpopUp">
        <div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
        <div class="relative w-full max-w-xl">
        <!--content-->
        <div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
            <!--header-->
            <div class="flex items-center justify-between popupheadingcontainer rounded">
            <h1>Import files</h1>
            <button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
                <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
            </button>
            </div>
            <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
      <div class='flex flex-col h-full'>
        <div class="flex-1 overflow-auto">
            <div class="impactcontainer popupbodycontainer">
            <div class="formcontainer flex flex-col">
                <div class="row flex flex-col mt-2">
                <div>
                    <label class="controllabel">File Name </label>
                    <input class="inputboxstyling text-xs mt-2" type="text" v-model.trim="inputFileName" placeholder="Filename" @input="v$.inputFileName.$touch()" :class="{'is-invalid': v$.inputFileName.$error }"/>
                    <div v-if="v$.inputFileName.$error " class="text-red-500">
                      <div class="error-text text-xs" v-if="v$.inputFileName.required.$invalid">Required</div>
                      <div v-else-if="v$.inputFileName.required && v$.inputFileName.restrictCharacters50.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
                </div>
                <div class="pt-3">
                    <label class="controllabel">Attachment</label>
                    <input type="file" ref="fileInput" class="hidden" id="upload" @change="handleFileUpload"/>
                    <div class="w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2" :class="{'is-invalid':v$.fileToUpload.$error || pdfValidation}">
                        <!-- <label htmlFor="upload" class="controllabel">Upload File</label> -->
                        <label for="upload" class="cursor-pointer">
                          <div class="float-right text-white flex justify-center heightForDiv items-center w-9 bg-primary"><img src="@/assets/Browse.svg" /></div>
                          <!-- <div v-if="fileName" class="text-xs p-1">{{ fileName }}</div> -->
                          <div v-if="fileName == ''" class="text-sm text-mediumGrey heightForDiv">
                            {{ placeholder }}
                          </div>
                          <div v-if="fileName != ''" class="text-sm heightForDiv">
                            {{ fileName }}
                          </div>
                        </label>
                    </div>
                </div>
                
                <div v-if="v$.fileToUpload.$error || pdfValidation" class="text-red-500">
                    <div class="error-text text-xs" v-if="v$.fileToUpload.$invalid && !pdfValidation">File upload is required</div>
                    <div v-if="pdfValidation && !v$.fileToUpload.$invalid" class="text-red-500 text-xs">Upload only pdf</div>
                </div>
                </div>
            </div>
            </div>
        </div>
      <!--footer-->
      <div>
          <div class="border-b border-solid border-lightgrey mx-5"></div>
          <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
            <button class="btnprimary" @click="handleFileChange" :class="(inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary'" :disabled="clickOnButton">Save</button>
        </div>
      </div>
      </div>
  </div>
        </div>
        </div>
    </popup>
    <div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
      <div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
      <div class="evidence-delete-dialog">
        <div class="evidence-delete-dialog-title">
          <div class="evidence-delete-warning">
            <img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
          </div>
          <span>Delete Evidence</span>
        </div>
        <p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
        <div class="evidence-delete-dialog-actions">
          <button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
          <button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
        </div>
      </div>
    </div>
    <div v-if="linkEvidencePopup" class="link-existing-confirm">
      <div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
      <div class="link-existing-dialog">
        <div class="link-existing-title">
          <span class="link-existing-warning" aria-hidden="true">
            <img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
          </span>
          <span>Link Existing Evidence</span>
        </div>
        <p class="link-existing-message">Select evidence from the past year listed below.</p>
        <div class="link-existing-tables">
          <div class="link-existing-section-row">
            <div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
            <button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
              <img src="@/assets/filter.svg" class="filterIcon" />
              Filters
            </button>
          </div>
          <div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
            <table class="link-existing-table">
              <thead>
                <tr>
                  <th class="link-existing-col-check"></th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('filename')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TITLE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TASK ID</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TYPE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">EVIDENCE DATE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                </tr>
                <tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
                  <td class="link-existing-col-check"></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
                  <td></td>
                </tr>
              </thead>
              <tbody v-if="filteredSortedExistingEvidences.length">
                <tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
                  <td class="link-existing-col-check">
                    <input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
                  </td>
                  <td :title="row.filename">{{ row.filename }}</td>
                  <td>{{ row.sourceTaskId }}</td>
                  <td>{{ existingEvidenceTypeLabel(row) }}</td>
                  <td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="link-existing-empty" colspan="5">No Records Found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="link-existing-actions">
          <button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
          <button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.kpi-title-select-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  position: relative;
}
.kpi-result-popup,
.kpi-result-popup fieldset,
.kpi-result-popup .formcontainer,
.kpi-result-popup .statuscontainer {
  min-width: 0;
  max-width: 100%;
}
:deep(.kpi-title-select.p-select) {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  display: flex !important;
}
:deep(.kpi-title-select .p-select-label) {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 0 !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
}
:deep(.kpi-title-select .p-select-dropdown) {
  flex-shrink: 0;
}
:deep(.kpi-title-select .p-select-overlay) {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  left: 0 !important;
  right: 0 !important;
  box-sizing: border-box;
}
:deep(.kpi-title-select .p-select-option) {
  height: auto !important;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.25;
}
.primary{
color:#1976d2;
}
.w-80{
  width: 80%;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey,.p-select.bg-disabledgrey.p-focus{
  background-color: #a4a4a4 !important;
  border:1px solid #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow,.p-select.bg-yellow.p-focus{
  background-color: #FF9900 !important;
  border:1px solid #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen,.p-select.bg-electricGreen.p-focus{
  background-color: #8600F0 !important;
  border:1px solid #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen,.p-select.bg-lightgreen.p-focus{
  background-color: #00B050 !important;
  border:1px solid #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred,.p-select.bg-darkred.p-focus{
  background-color: #C00000 !important;
  border:1px solid #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error,.p-select.bg-error.p-focus{
  background-color: #FF0000 !important;
  border:1px solid #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
}
:deep(.p-select.textColorWhite .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}
:deep(.textColorWhite .p-select-dropdown-icon){
  color: white !important;
}
/* Add others as needed */

/* .progressbarB {
border: 2px solid #e9e9e9;
background: #e9e9e9;
position: relative;
top: -8px;
z-index: 1;
} */

.Vue-Toastification__container {
z-index: 999999999 !important;
}
.btndisabledForFilter{
border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(233 233 233 / var(--tw-bg-opacity));
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: .75rem;
  --tw-text-opacity: 1;
  color: rgb(77 77 77 / var(--tw-text-opacity));

}
.heightForDiv{
height : 29.333px;
padding-left: 0.625rem;
padding-right: 0.625rem;
padding-top: 0.25rem;
padding-bottom: 0.25rem;
}
.taskStatusOptions{
background-color: white; 
color: rgba(77, 77, 77, var(--tw-text-opacity))
}
.taskStatusOptionsForNotStarted{
  background-color: #e9e9e9; 
color: rgba(77, 77, 77, var(--tw-text-opacity))
}
.table-ellipsis {
display:-webkit-box !important;
-webkit-line-clamp: 1 !important;
-webkit-box-orient: vertical !important;
overflow: hidden !important;
text-overflow: ellipsis !important;
}
.paddingforDescription{
padding-left:1.9rem;
}
.paddingrightforDescription{
padding-right:0.3rem;
}
.numberBorder {
border-top: 1px solid #e9e9e9;
border-right: 1px solid #e9e9e9;
border-bottom: 1px solid #e9e9e9;
}
.numberNavy {
border-left: 1px solid #152a43;
border-left-width: 2px;
}
.progress {
background: #1976d2;
position: relative;
border-radius: 4px;
z-index: 2;
}
.primaryBackground {
background-color: #152a433b;
}
.descriptionToggle {
height:  calc(100vh - 230px);
}
.tabStructure {
height: calc(100vh - 165px);
}
.descriptionToggle::-webkit-scrollbar {
width: 0 !important;
height: 0 !important;
background: transparent;
}
.w-30{
width:30%;
}
.w-20{
width:20%;
}
.w-23{
width:23%;
}
.w-27{
width:27%;
}
.w-50{
width:50%;
}
.fontSize10PX{
font-size: 10px;
}
.descriptionToggle::-webkit-scrollbar-thumb {
background: transparent;
}
.heightFixing {
height: calc(100vh - 220px);
}
.thirtyWidthToggle::-webkit-scrollbar {
width: 0 !important;
height: 0 !important;
background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
background: transparent;
}
.thirtyWidthToggle{  
   height: calc(100vh - 250px);
}
option {
background-color: #ffffff;
color: #000000;
border-color: pink transparent transparent transparent;
}
.textColorWhite {
color: white;
}
.pendingEvidence {
background-color: #8600f040;
}

.labelWidth {
min-width: 7rem;
}

.progressbarB {
border: 2px solid #e9e9e9;
background: #e9e9e9;
position: relative;
top: -8px;
border-radius: 5px;
}
.framework{
  padding: 12px 170px 12px 12px;
}
.custom-select {
background-image: url("@/assets/Collapse.svg") !important;
background-repeat: no-repeat no-repeat;
background-position: center center;
background-size: 12px 12px;
background-position: right 15px center; /* Change the px value here to change the distance */
-moz-appearance: none;
-webkit-appearance: none;
appearance: none;
}
.progress {
border-radius:16px;
background: #1976d2;
}
.inputboxstyling1 {
display: block;
width: 100%;
border-radius: 0.25rem;
border-width: 1px;
border-style: solid;
--tw-border-opacity: 1;
border-color: rgba(233, 233, 233, var(--tw-border-opacity));
--tw-bg-opacity: 1;
/* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
padding-left: 0.625rem;
padding-right: 0.625rem;
padding-top: 0.25rem;
padding-bottom: 0.25rem;
font-size: 0.875rem;
line-height: 1.25rem;
font-weight: 300;
--tw-text-opacity: 1;
/* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}
.colorWhite {
color: white;
}
.adjust {
flex-shrink: 0;
}
.progress-bar::after {
content: '';
position: absolute;
top: 0;
bottom: 0;
/* margin-left: 5px;
margin-right: 5px; */
width: 20px; /* Adjust the thickness of the line as needed */
/* background-color: #fff; Color of the indicator line performanceIndicator */ 
/* background-image: url("@/assets/performanceIndicatior.svg") !important; */
/* background-repeat: no-repeat no-repeat;
background-position: center center; */
/* left: calc(var(--progress)); Position based on progress */
}
.progress-bar100::after {
content: '';
position: absolute;
top: 0;
bottom: 0;
/* margin-left: 5px;
margin-right: 5px; */
width: 20px; /* Adjust the thickness of the line as needed */
/* background-color: #fff; Color of the indicator line performanceIndicator */ 
background-image: url("@/assets/performanceIndicatior.svg") !important;
background-repeat: no-repeat no-repeat;
background-position: center center;
left: calc(var(--progress100) - 20px);

/* right: calc(var(--progress) - 15px); */
}
.progress-container {
margin-top: 8px;
width: 100%;
height: 10px;
background-color: #f0f0f0;
border-radius: 5px;
overflow: hidden;
}

.progress-bar {
height: 100%;
position: relative;
border-radius: 5px;
--progress: 0%;
}
.progress-bar100 {
height: 100%;
border-radius: 5px;
position: relative;
--progress100: 0%;
}
.onepixel{
padding-bottom : 0.5px;
}
.progress-indicator-container {
position: relative;
height: 15px;
font-size: 12px;
/* margin-top: 5px; */
}
.progress-indicator-count {
position: relative;
height: 13px;
font-size: 12px;
margin-top: -4px;
}
.indicatorIcon100::after {
content: '';
position: absolute;
top: 0;
bottom: 0;
/* margin-left: 5px;
margin-right: 5px; */
width: 18px; /* Adjust the thickness of the line as needed */
/* background-color: #fff; Color of the indicator line performanceIndicator */ 
background-image: url("@/assets/performanceIndicatior.svg") !important;
background-repeat: no-repeat no-repeat;
background-position: center center;
transform: rotate(180deg);
left: calc(var(--progress100) - 20px);
/* right: calc(var(--progress) - 15px); */
}
.indicatorIcon{
height: 100%;
width: 18px;
background-image: url("@/assets/performanceIndicatior.svg") !important;
background-repeat: no-repeat no-repeat;
background-position: center center;
transform: rotate(180deg);
position: relative;
left: calc(var(--progress));
}
.indicator {
position: absolute;
/* top: 50%;
left: 50%;
color: rgb(0, 0, 0); */
}
::-webkit-scrollbar {
width: 3px !important;
}
.bgDisabledGrey{
background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
background-color: rgba(21, 42, 67, 0.2);
}
:deep(.p-tab){
  padding-top: 0px !important;
}
:deep(.p-tabpanels){
  padding: 0px !important;
}
:deep(.p-tablist-content){
  margin-left: 0px !important;
  margin-right: 0px !important;
}
:deep(.p-tablist-nav-button){
  box-shadow:none  !important;
}
@media only screen and (min-width: 320px) and  (max-width:820px) {
  :deep(.p-tablist-tab-list){
    width: max-content !important;

  }
}
@media only screen and (min-width: 820px) and  (max-width:1440px) {
  :deep(.p-tablist-tab-list){
    width: 100% !important;

  }
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
// import breadCrumbs from '@/components/breadCrumbs.vue';
import breadCrumb from "@/components/breadCrumb.vue";
import { helpers, required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import popup from "@/components/popup.vue";
import { groupBy } from "lodash";
import { emitter, toast } from "@/main";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import tableData from "@/components/tableData.vue";
import commentsEditor from "@/components/commentsEditor.vue";
import safeHtml from "@/components/safeHtml.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
const restrictCharacters50 = helpers.regex(/^.{0,50}$/);
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
export default defineComponent({
props: {
  complianceId: { type: [String, Number], default: null },
  taskId: { type: [String, Number], default: null },
  modalMode: { type: Boolean, default: false },
},
emits: ['header-info', 'open-nested'],
data(): any {
  return {
    v$: useVuelidate(),
    selectedTabIndex: 1,
    tabHead: [
      { displayName: "Details", id: 1 },
      { displayName: "Documents", id: 2 },
      { displayName: "Related Tasks", id: 3 },
      { displayName: "Evidence", id: 4 },
      { displayName: "Comments", id: 5 },
      { displayName: "Findings", id: 6 },
      { displayName: "Result", id: 7 },
      { displayName: "History", id: 8 },
    ],
    routesArray: [],
    progress: 0,
    tableRow: [],
    length:[],
    tabDataLoading:false,
    Headers: ['TaskId','Title','Frequency','Status'],
    progressBarColor: "linear-gradient(to right, red, green)",
    tasksForCompliance: [],
    presentTaskObject: {},
    linkEvidencePopup: false,
    linkEvidenceTasks: [],
    selectedExistingEvidences: [],
    existingEvidenceSortKey: '',
    existingEvidenceSortDir: 'asc',
    showExistingEvidenceFilters: false,
    existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
    showDeleteEvidenceConfirm: false,
    deleteEvidenceIndex: null,
    kpisObject: [],
    kpiFieldVisibility:false,
    controlDetailsArray: [],
    presentComplianceObject: [],
    teamLeaderValue: '',
    optionsUserArray: [],
    optionsUsersList: [],
    inputFileName: '',
    severity:'',
    fileName: '',
    allProcess:[],
    optionSystemArray:[],
    optionsActivityArray:[],
    // allSystems:[],
    // allProjects:[],
    optionsProjectArray:[],
    resultArray1:[
    {
        id: 1,
        value: 'Control'
      },
      
    ],
    resultArray2:[
      {
        id: 2,
        value: 'KPI'
      }
    ],
    resultArray:[
    {
        id: 1,
        value: 'Control'
      },
      {
        id: 2,
        value: 'KPI'
      }
    ],
    controlsArray: [],
    TeamOwnerOptions:[],
    // greaterThanOrEqualActual: false,
    orgUsersList: [],
    users: [],
    allEntities: [],
    newHistory: true,
    pdfValidation: false,
    locationObject: [],
    controlFrequencyArray: [
      { label: 'Transactional', id: 1 },
      { label: 'Daily', id: 2 },
      { label: 'Weekly', id: 3 },
      { label: 'Monthly', id: 4 },
      { label: 'Quarterly', id: 5 },
      { label: 'Semi Annualy', id: 6 },
      { label: 'Annualy', id: 7 },
      { label: 'Ad-Hoc', id: 8 }
    ],
    findingCategoryData: [
              {
                  id: 1,
                  value: 'Minor'
              },
              {
                  id: 2,
                  value: 'Major'
              },
              {
                  id: 3,
                  value: 'OFI'
              },
              {
                  id: 4,
                  value: 'Observation'
              }
      ],
    kpislength:'',
    TaskDetailsDropDown: {
      taskStatus: "",
      assigneeDropDown: "",
    },
    colorData: [
      {
        id: 1,
        progressValue: "Very Low Risk",
        color: "bg-lightgreen",
        kpiResultValue: "Very High Performance",
      },
      {
        id: 2,
        progressValue: "Low Risk",
        color: "bg-green",
        kpiResultValue: "High Performance",
      },
      {
        id: 3,
        color: "bg-yellow",
        progressValue: "Moderate Risk",
        kpiResultValue: "Moderate Performance",
      },
      {
        id: 4,
        color: "bg-error",
        progressValue: "High Risk",
        kpiResultValue: "Low Performance",
      },
      {
        id: 5,
        color: "bg-darkred",
        progressValue: "Very High Risk",
        kpiResultValue: "Very Low Performance",
      },
    ],
    // taskStatusData: [
    //     {
    //         id: 10401,
    //         status: 'Not Started'
    //     },
    //     {
    //         id: 10415,
    //         status: 'In Review'
    //     },
    //     {
    //         id: 10414,
    //         status: 'Pending Evidence'
    //     },
    //     {
    //         id: 10416,
    //         status: 'Evidence Uploaded'
    //     },
    //     {
    //         id: 10417,
    //         status: 'Completed'
    //     }
    // ],
    storingKpiIds:[],
    severityValues:[
      {
        id:1,
        value:'Very High'
      },
      {
        id:2,
        value:'High'
      },
      {
        id:3,
        value:'Moderate'
      },
      {
        id:4,
        value:'Low'
      },
      {
        id:5,
        value:'Very Low'
      }
    ],
    taskStatusData: [
      {
        id: 10401,
        status: "Not Started",
      },
      {
        id: 10415,
        status: "In Review",
      },
      {
        id: 10414,
        status: "Pending Evidence",
      },
      {
        id: 10416,
        status: "Evidence Uploaded",
      },
      {
        id: 10403,
        status: "Completed",
      },
      {
        id: 10417,
        status: "Not Applicable",
      },
    ],
    terminatedStatus: [
      {
        id: 10418,
        status: "Terminated",
      }
    ],
    kpisArray:[],
    assigneeData: [],
    descriptionObject: {},
    kpi_data: [],
    controlRecurringArray: [
      { label: "Daily", id: 1 },
      { label: "Weekly", id: 2 },
      { label: "Monthly", id: 3 },
      { label: "Quarterly", id: 4 },
      { label: "Half-Yearly", id: 5 },
      { label: "Yearly", id: 6 },
    ],
    controlObject : false,
    kpiProgress: 0,
    controlProgress: 0,
    controlResultsForCompliance: [],
    oldComments: true,
    newComment: "",
    titleLength: 0,
    comments: [],
    showPopUp: false,
    kpishowPopUp:false,
    resultOfPopulation: true,
    resultOfNegativeOutput: true,
    conditionForControlOrKPI: false,
    resultOfNegativePopulation: true,
    showPopUpForResult:false,
    showPopUpForKpi:false,
    comment: "",
    fileToUpload: '',
    btnDisabled: true,
    importpopUp: false,
    findingsForCompliance: [],
    resultsForCompliance: [],
    complianceFrameworkArray: [],
    allFrameWorkControls: [],
    eachControlDocuments: [],
    workLogObject: [],
    findingsObject: {
      findingId: '',
      findingEvidence: "",
      // findingCategory: "",
      finding: "",
      findingRelatedTo: "",
      control_id: "",
      kpi_id: "",
    },
    findingsObjectDummy: {
      findingId: '',
      findingEvidence: "",
      // findingCategory: "",
      finding: "",
      findingRelatedTo: "",
      control_id: "",
      kpi_id: "",
    },
    resultObject: {
      resultfor:"",
      controlorKpi:"",
      actualOutput: "",
      totalPopulation: "",
      riskSeverity: "",
      comments: "",
    },
    resultObjectDummy: {
      resultfor:"",
      controlorKpi:"",
      actualOutput: "",
      totalPopulation: "",
      riskSeverity: "",
      comments: "",
    },
    kpiDetailsArray:[],
    getControlNumber:[],
    reportingFrequency: "",
    selectedBG: "bg-disabledgrey colorWhite",
    newTeamLeader : '',
    clickOnButton: false,
    clickOnButtonForFinding : false,
    clickOnButtonForResult : false,
    evidenceArray:[],
    placeholder: 'Select a File',
    teamReviewerValue:'',
    selectedTabObj:{},
    filteredOptions: [],
  };
  
},

validations() {
  return {
    findingsObject: {
      // findingId: {required},
      finding: { required, restrictCharacters300 },
      findingEvidence:{required},
      findingRelatedTo: { required },
      control_id: {
        required: requiredIf(function (this: any) {
          return Number(this.findingsObject.findingRelatedTo) === 1;
        }),
      },
      kpi_id: {
        required: requiredIf(function (this: any) {
          return Number(this.findingsObject.findingRelatedTo) === 2;
        }),
      },
      // findingCategory:{required},
    },
    resultObject: {
      controlorKpi: { required } ,
      actualOutput: { required: requiredIf(function (this: any) {
        const population = this.resultObject.totalPopulation;
        if (population === '' || population == null) {
          return true;
        }
        return Number(population) !== 0;
      }) },
      totalPopulation: {required},
      riskSeverity: { required },
      comments: {required, restrictCharacters300},
    },
    inputFileName: { required, restrictCharacters50 },
    fileToUpload: { required }
  };
},
components: {
  breadCrumb,
  popup,
  Multiselect,
  tableData,
  commentsEditor,
  safeHtml,
  dotsLoader,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Select,
  AutoComplete
},
mounted(){
  emitter.off('addedComments');
  emitter.on('addedComments', (data: any) => {
    this.comment = data.comments
    this.addComment();
  });
},
beforeUnmount() {
   sessionStorage.removeItem('selectedTab')
 },
async created() {
  this.tabDataLoading = true
  const savedTabKey = sessionStorage.getItem('selectedTab');
  if (savedTabKey) {
      const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
      if (savedTab) {
     this.toggleTabs(savedTab);
      }
  else{
         this.selectedTabObj = { displayName: "Description", id: 1 };
  }
  }
else{
         this.selectedTabObj = { displayName: "Description", id: 1 };
}
  // await this.toggleTabs({ displayName: "Description", id: 1 });
  await this.getControls();
  // await this.getControlDocuments();
  await this.getallEntities();
  await this.getallUsers();
  await this.getAllTeams();
  // await this.getAllSystems();
  // await this.getAllProjects();
  // await this.getAllBusinessProcesses();
  await this.getPresentComplianceObject();
  await this.getTaskHistoryObject();
  await this.getTasksForCompliance(
    this.currentComplianceId,
    this.currentTaskId
  );
  await this.getSingleComplianceFindings();
  this.tabDataLoading = false
  // this.controlEditPopupDummy = { ...this.controlEditPopup };
  let complianceId = this.currentComplianceId;
  if(this.presentTaskObject.kpis == null || this.presentTaskObject.kpis == undefined && this.presentTaskObject.kpis.length == null || this.presentTaskObject.kpis.length == undefined){
    this.controlObject = true;
  }else{
    this.controlObject = false;
  }
  this.titleLength = this.presentTaskObject.controlTitle ? this.presentTaskObject.controlTitle.length:0

  // this.routesArray = [
  //   { name: "Compliance", routeName: "createCompliance" },
  //   // { name: 'Task Status / Analytics', routeName: 'view-compliance'},
  //   {
  //     name: "Compliance-Tasks",
  //     routeName: "start-Compliance",
  //     id: complianceId,
  //   },
  //   { name: this.presentTaskObject.taskId, routeName: "edit" },
  // ];
  
  if(this.presentTaskObject.results){
    this.presentTaskObject.results.forEach((element : any) => {
    this.kpiDetailsArray.push(element.controlorKpi)
    
  });
  
  this.length = this.presentTaskObject.results.length
  }
  if(this.presentTaskObject.kpis){
    this.kpislength = this.presentTaskObject.kpis.length
  }
  if (Object.keys(this.$route.query).includes("myTasks")) {
    this.routesArray = [
      { name: "My Tasks", routeName: "myTasks" },
      { name: this.presentTaskObject.taskId, routeName: "complianceTasks" },
    ];
  } else {
    this.routesArray = [
      { name: 'Compliance', routeName: "compliance" },
      { name: String(this.presentComplianceObject.complianceId).toUpperCase(), routeName: "viewCompliance" },
      { name: "Tasks", routeName: "start-Compliance" },
      { name: this.presentTaskObject.taskId, routeName: "complianceTasks" },
    ];
  }
  this.conditionForResultBtn();
  if(this.presentComplianceObject.teamLeader != undefined){
      this.newTeamLeader = this.presentComplianceObject.teamLeader
  }
},
computed: {
  ...mapGetters({ userInfo: "userInfo",dbPriority: 'dbPriority' ,dbFrequency:'dbFrequency', dbSeverity: 'dbSeverity' }),
  currentComplianceId(): any {
    return this.complianceId || this.$route.params.complianceId;
  },
  currentTaskId(): any {
    return this.taskId || this.$route.params.taskId;
  },
  filteredTaskStatusData: function ():any {
      return this.taskStatusData.filter((i:any) => {
          return !((i.id == 10403 || i.id == 10417) && this.teamReviewerValue != this.userInfo._id);
      });
  },
  isCompliantInputEnabled: function (): boolean {
    const population = this.resultObject.totalPopulation;
    if (population === '' || population == null) {
      return true;
    }
    return Number(population) !== 0;
  },
  taskMappedControlOptions(): { _id: string; label: string }[] {
    const controlId = this.presentTaskObject?.linkedControlID
      ? String(this.presentTaskObject.linkedControlID)
      : "";
    if (!controlId) {
      return [];
    }
    return [
      {
        _id: controlId,
        label: this.getTaskMappedControlDisplay(),
      },
    ];
  },
  findingRelatedToOptions(): { label: string; value: number }[] {
    const options = [{ label: "Control", value: 1 }];
    const kpis = this.presentTaskObject?.kpis;
    if (Array.isArray(kpis) && kpis.length > 0) {
      options.push({ label: "KPI", value: 2 });
    }
    return options;
  },
  taskHasActiveKpis(): boolean {
    const kpis = this.presentTaskObject?.kpis;
    return Array.isArray(kpis) && kpis.length > 0;
  },
  pastYearExistingEvidences(): any[] {
    const currentId = String(this.currentTaskId || '');
    const currentUrls = new Set((this.presentTaskObject?.files || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
    const userId = String(this.userInfo?._id || '');
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    const rows: any[] = [];
    (this.linkEvidenceTasks || []).forEach((task: any) => {
      if (String(task?._id || '') === currentId || !Array.isArray(task?.files)) return;
      const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
      if (!sourceTaskId) return;
      task.files.forEach((doc: any) => {
        if (!doc?.url || currentUrls.has(doc.url)) return;
        if (doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== sourceTaskId) return;
        if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '') return;
        if (String(doc.createdBy || '') !== userId) return;
        const filename = doc.filename || doc.name;
        if (!filename) return;
        const evidenceTime = Date.parse(doc.evidenceDate);
        if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
        rows.push({
          ...doc,
          filename,
          sourceTaskId,
          optionKey: `${sourceTaskId}|${doc.url}`
        });
      });
    });
    return rows;
  },
  existingEvidenceSortClass(): string {
    return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
  },
  filteredSortedExistingEvidences(): any[] {
    const filters = this.existingEvidenceFilters || {};
    const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
      const title = String(row.filename || '').toLowerCase();
      const taskId = String(row.sourceTaskId || '').toLowerCase();
      const typeLabel = this.existingEvidenceTypeLabel(row).toLowerCase();
      if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
      if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
      if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
      return true;
    });
    const key = this.existingEvidenceSortKey;
    if (!key) return rows;
    const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
    return rows.sort((a: any, b: any) => {
      if (key === 'evidenceDate') {
        const aTime = Date.parse(a?.evidenceDate);
        const bTime = Date.parse(b?.evidenceDate);
        if (aTime < bTime) return -1 * modifier;
        if (aTime > bTime) return 1 * modifier;
        return 0;
      }
      if (key === 'sourceTaskId') {
        const aVal = String(a?.sourceTaskId || '');
        const bVal = String(b?.sourceTaskId || '');
        const aNumMatch = aVal.match(/\d+$/);
        const bNumMatch = bVal.match(/\d+$/);
        if (aNumMatch && bNumMatch) {
          const aNum = parseInt(aNumMatch[0], 10);
          const bNum = parseInt(bNumMatch[0], 10);
          if (aNum < bNum) return -1 * modifier;
          if (aNum > bNum) return 1 * modifier;
          return 0;
        }
        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      }
      const aVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(a) : String(a?.filename || '');
      const bVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(b) : String(b?.filename || '');
      if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
      if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
      return 0;
    });
  },
},
methods: {
  asyncFind(event:any) {
    const query = event.query.toLowerCase();
    if (query == "") {
          this.filteredOptions = [];
        }
    else if (query.length >= 1) {
    this.filteredOptions = this.evidenceArray.filter((obj:any) =>
      obj.toLowerCase().includes(query.toLowerCase())
    );
    }
  },
  getEntity(id :any){
    
    let entity:any
    if(id != undefined || id != null){
      entity = this.allEntities.find((data:any)=> { return data._id == id})
      if(entity != undefined){
        // if(entity.entityType==1){
        //   return 'Global'
        // }
        return entity.entityDisplayName
      } else {
        return 'N/A'
      }
    } else {
      return 'N/A'
    }
  },
  // async getAllProjects(){
	// 		this.projectDataArray = [],
	// 		await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((res: any) => {
	// 			this.allProjects = res.data;})
  //       for(let i=0;i<this.allProjects.length;i++){
	// 			this.optionsProjectArray.push({ label: this.allProjects[i].projectName, value: this.allProjects[i].projectType });
	// 		}
	// 	},
  // async getAllBusinessProcesses() {
  //           await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
	// 			this.allProcess = result.data
  //           });
	// 		for(let i=0;i<this.allProcess.length;i++){
	// 			this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id });
	// 		}
	// 	},
		// async getAllSystems(){
		// 	await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
		// 		this.allSystems = result.data;
		// 		// this.orgUsersList = res.data
		// 		for (var i = 0; i < this.allSystems.length; i++) {
		// 			this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
		// 		}
		// 	});
		// },
  
  colorLabelText(value: any) {
      if (value == 1) {
          return ["text-lightgreen font-semibold"];
      } else if (value == 2) {
          return ["text-green font-semibold"];
      } else if (value == 3) {
          return ["text-yellow font-semibold"];
      } else if (value == 4) {
          return ["text-error font-semibold"];
      } else if (value == 5) {
          return ["text-darkred font-semibold"];
      }
    },
  colorLabelBg(value: any) {
      if (value == 1) {
          return ["bg-veryLowColor border-solid border border-lightgreen"];
      } else if (value == 2) {
          return ["bg-lowColor border-solid border border-green"];
      } else if (value == 3) {
          return ["bg-moderateColor border-solid border border-yellow"];
      } else if (value == 4) {
          return ["bg-highColor border-solid border border-error"];
      } else if (value == 5) {
          return ["bg-veryHighColor border-solid border border-darkred"];
      }
    },
  getProirityLabel(val:any){
      if (val === 'N/A') { 
          return ''; 
      } else {
        let a = this.dbPriority.find((obj: any) => obj.value == val);
        return (val && typeof val === 'number') ? a.key : '';
      }
    },
  getTargetDetails(data: any) {
    let tier:any;
    if (data.categoryType == 10107) {
      tier = 'Activity';
      // const activity = this.optionsActivityArray.find(
      //   (activity: any) => data.activityId?.toString() == activity.value?.toString()
      // );
      // tierInfo = activity ? activity.label : 'N/A';
    } else if (data.categoryType == 10108) {
      tier = 'System';
      // const system = this.optionSystemArray.find(
      //   (sys: any) => data.systemId?.toString() == sys.value?.toString()
      // );
      // tierInfo = system ? system.label : 'N/A';
    }
    else{
      tier = 'N/A';
    }
    return { tier };

  },
  getKpis(){
    if(this.presentTaskObject.kpis && this.resultsForCompliance.length == 0){
      this.kpisArray = this.presentTaskObject.kpis
    } else if(this.presentTaskObject.kpis && this.resultsForCompliance.length > 0){
      const resultsKpiDescriptions = this.presentTaskObject.results.map((result: any) => result.controlorKpi);

      // Filter the presentTaskObject.kpis array to exclude KPIs that are in resultsKpiDescriptions
      this.kpisArray = this.presentTaskObject.kpis.filter((kpi: any) => !resultsKpiDescriptions.includes(kpi._id));

      // Log the results for debugging purposes
    }
  },
  conditionForResultBtn(){
    // presentTaskObject.results.length
    // console.log("this.TaskDetailsDropDown.taskStatus", this.TaskDetailsDropDown.taskStatus);
    // console.log("check", (Object.keys(this.presentTaskObject).includes('results') || this.presentTaskObject.kpis == undefined || this.presentTaskObject.kpis == null && this.presentTaskObject.results.length != this.presentTaskObject.kpis.length) && (Object.keys(this.presentTaskObject).includes('controlResults') && this.presentTaskObject.controlResults.length != 0))
    let condition = this.TaskDetailsDropDown.taskStatus == 10403 || this.TaskDetailsDropDown.taskStatus == 10417 || this.TaskDetailsDropDown.taskStatus == 10418 || this.TaskDetailsDropDown.taskStatus == 10401;
    let secondCondition = false;
    let thirdCondition = false;
    // let fourthCondition = false;
    if(Object.keys(this.presentTaskObject).includes('kpis')){
      thirdCondition = (Object.keys(this.presentTaskObject).includes('controlResults') && this.presentTaskObject.controlResults.length != 0);
      secondCondition = (Object.keys(this.presentTaskObject).includes('results') && this.presentTaskObject.results.length == this.presentTaskObject.kpis.length)
    }
    // console.log("fourthCondition", fourthCondition)
    if(condition || (secondCondition && thirdCondition) ){
      return true;
    }else{
      return false;
    }
  },
  getObj(){
    if(this.resultObject.resultfor == 1){
      this.resultObject.controlorKpi = this.presentTaskObject.clientUniqueId
    } else if(this.resultObject.resultfor == 2){
      this.resultObject.controlorKpi = ""
      // this.resultArray = 
    }
  },
  asyncFind1(query:any){
    query=query.query.trim();
          if(query == ''){
              this.TeamOwnerOptions = []
          }else if(query.length >= 1){
              this.TeamOwnerOptions = this.optionsUsersList.filter((obj:any)=>{
                if(obj.value != this.presentTaskObject.reviewer){
                  return obj.label.toLowerCase().includes(query.toLowerCase());
                }
              })
          }
  },
  updateProgress(value: any) {
    this.progress = value;
  },
  // async updateTaskStatus(status: any) {
  //   let payload: any = { statusCode: status };
  //   await this.updateComplianceTask(4, payload);
  // },
  async onTaskStatusChange(event: any) {
    const status = event && typeof event === 'object' && 'value' in event
      ? event.value
      : (event ?? this.TaskDetailsDropDown.taskStatus);
    await this.updateTaskStatus(status);
  },
  async updateTaskStatus(status: any) {
    const statusCode = status && typeof status === 'object' && 'value' in status
      ? status.value
      : status;
    if (statusCode == null || statusCode === '') {
      return;
    }
    let payload: any = { statusCode: statusCode };
    if(statusCode == 10403){
      if((this.presentTaskObject.controlResults != undefined || this.presentTaskObject.controlResults != null) && this.presentTaskObject.controlResults.length>0){
        await this.updateComplianceTask(4, payload);
      } else {
      this.$nextTick(() => {
        this.TaskDetailsDropDown.taskStatus = this.presentTaskObject.statusCode;
      });
        toast.error(`Add Control Result`, {
          timeout: 3000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
    } else {
      await this.updateComplianceTask(4, payload);
    }
    
  },
  colorRiskText(severity: any) {
          if (severity == 1) {
              return ['text-lightgreen text-xs font-semibold'];
          } else if (severity == 2) {
              return ['text-green text-xs font-semibold'];
          } else if (severity == 3) {
              return ['text-yellow text-xs font-semibold'];
          } else if (severity == 4) {
              return ['text-error text-xs font-semibold'];
          } else if (severity == 5) {
              return ['text-darkred text-xs font-semibold'];
          }
      },
    colorRiskBg(severity: any) {
          if (severity == 1) {
              return ['bgLightGreen border-solid border border-lightgreen'];
          } else if (severity == 2) {
              return ['bgGreen border-solid border border-green'];
          } else if (severity == 3) {
              return ['bgYellow border-solid border border-yellow'];
          } else if (severity == 4) {
              return ['bgError border-solid border border-error'];
          } else if (severity == 5) {
              return ['bgdarkred border-solid border border-darkred'];
          }
      },
      getSeverityBg(severity:any) {
        if (severity == 1) {
          return 'bg-lightgreen';
        } else if (severity == 2) {
          return 'bg-green ';
        } else if (severity == 3) {
          return 'bg-yellow';
        } else if (severity == 4) {
          return 'bg-error';
        } else if (severity == 5) {
          return 'bg-darkred';
        } else {
          return '';
        }
      },
      /** Performance Analysis bar color from % (high = green), not risk severity. */
      getPerformanceBg(percent: any) {
        const p = Number(percent);
        if (percent == null || percent === '' || Number.isNaN(p)) {
          return '';
        }
        // Invert severity scale: high performance → green (1), low → darkred (5)
        let band = 3;
        if (p <= 20) {
          band = 5;
        } else if (p <= 40) {
          band = 4;
        } else if (p <= 60) {
          band = 3;
        } else if (p <= 80) {
          band = 2;
        } else {
          band = 1;
        }
        return this.getSeverityBg(band);
      },

  changeBackground() {
    if (this.TaskDetailsDropDown.taskStatus == 10401) {
      return "bg-disabledgrey textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10415) {
      return "bg-yellow textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10414) {
      return "bg-electricGreen textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10416) {
      return "bg-primary textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10403) {
      return "bg-lightgreen textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10417) {
      return "bg-darkred textColorWhite";
    } else if (this.TaskDetailsDropDown.taskStatus == 10418) {
      return "bg-error textColorWhite";
    } else {
      return "";
    }
  },
  colorComplianceText(status: any) {
    if (status == 10401) {
      return ["font-semibold text-xs text-disabledgrey"];
    } else if (status == 10402 || status == 10415) {
      return ["font-semibold text-xs text-yellow"];
    } else if (status == 10403) {
      return ["font-semibold text-xs text-lightgreen"];
    } else if (status == 10414) {
      return ["font-semibold mx-2 text-xs text-electricGreen"];
    } else if (status == 10416) {
      return ["font-semibold mx-2 text-xs text-primary"];
    } else if (status == 10417) {
      return ["font-semibold mx-2 text-xs text-darkred"];
    } else if (status == 10418) {
      return ["font-semibold mx-2 text-xs text-error"];
    }
  },
  colorComplianceBg(status: any) {
    if (status == 10401) {
      return ['bgDisabledGrey border-solid border border-disabledgrey'];
    } else if (status == 10402 || status == 10415) {
      return ['bgYellow border-solid border border-yellow'];
    } else if (status == 10403) {
      return ['bgLightGreen border-solid border border-lightgreen'];
    } else if (status == 10414) {
      return ['bgElectricGreen border-solid border border-electricGreen'];
    } else if (status == 10416) {
      return ['bgPrimary border-solid border border-primary'];
    }else if (status == 10417) {
      return ['bgdarkred border-solid border border-darkred'];
    }else if (status == 10418) {
      return ['bgError border-solid border border-error'];
    }
  },
  async toggleTabs(obj: any) {
    this.selectedTabIndex = obj.id;
    this.selectedTabObj = obj;
    //sessionStorage.setItem('selectedTab', obj.id);
    const complianceId = this.currentComplianceId;
    const taskId = this.currentTaskId
    await this.getTasksForCompliance(complianceId,taskId);
    await this.getTaskHistoryObject()
  },
  sortWorkLog() {
    this.newHistory = !this.newHistory;
    if(this.workLogObject.taskHistory.length != 0){
      this.workLogObject.taskHistory.sort().reverse();
    }
  },
  sortComments() {
    this.oldComments = !this.oldComments;
    if(Object.keys(this.presentTaskObject).includes('comments') && this.presentTaskObject.comments.length != 0){
      this.presentTaskObject.comments.sort().reverse();
    }
  },
  getSeverityLabel(cameId:any){
      if(cameId == null || cameId === '' || cameId === 'N/A'){
        return 'N/A'
      }
      // Already a label string (e.g. from older history entries)
      if (typeof cameId === 'string' && Number.isNaN(Number(cameId))) {
        return cameId;
      }
      const list = Array.isArray(this.dbSeverity) ? this.dbSeverity : [];
      let labelObj = list.find((l:any) =>
        l.value == cameId ||
        String(l.value) === String(cameId) ||
        Number(l.value) === Number(cameId)
      );
      if(labelObj == undefined){
          const fallback = (this.severityValues || []).find((l:any) =>
            l.id == cameId || Number(l.id) === Number(cameId)
          );
          return fallback?.value || String(cameId);
      }else{
          return labelObj.key;
      }
  },
  formatResultHistoryValue(field: any, value: any) {
    if (value == null || value === '') {
      return 'N/A';
    }
    if (field === 'Risk Severity') {
      return this.getSeverityLabel(value);
    }
    return value;
  },
  formatTime(time: any) {
    let now = moment(time);
    return now.format("DD-MM-YYYY, HH:mm:ss");
  },
  extractInitials(name: any) {
    const names = name.split(" ");
    return names
      .map((name: any) => name[0])
      .join("")
      .toUpperCase();
  },
  getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {             
				return user._id == person;
			});
			
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
  getTeamName(team: any) {
    let teamObj = this.users.find((obj: any) => {
      return obj._id == team;
    });
    if (teamObj == undefined) {
      return "";
    } else {
      let entityData = teamObj.entityType == 20301 ? teamObj.displayName : teamObj.entityDisplayName
      // this.presentTaskObject.entity = entityData != undefined ? entityData :'N/A'
      return teamObj.displayName;
    }
  },
  getDeptEntity(teamId: any) {
    let presentteamObject: any = this.users.find((obj: any) => {
      return obj._id == teamId;
    });
    if (presentteamObject != undefined && presentteamObject.entityType == 20301) {
      // let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
      return presentteamObject ? presentteamObject.entityName : 'N/A';
    } else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
      return presentteamObject ? presentteamObject.entityDisplayName : 'N/A';
    } else {
      return 'N/A'
    }
  },
  getLocation(teamId: any) {
    let presentteamObject: any = this.users.find((obj: any) => {
      return obj._id == teamId;
    });
    if (presentteamObject != undefined && presentteamObject.entityType == 20301) {
      let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
      return entityObj ? entityObj.entityName : 'N/A';
    } else {
      if (
        this.presentTaskObject.location == undefined ||
        this.presentTaskObject.location == null
      ) {
        return "N/A";
      } else {
        return this.getLocationName(
          this.presentTaskObject.location[0].entity
        );
      }
    }
  },
  async getTaskHistoryObject() {
    let complianceId = this.currentComplianceId;
    await this.$http
      .get(
        `${process.env.VUE_APP_MONITOR_API}/api/org/task/${this.currentTaskId}/getHistory`
      )
      .then((result: any) => {
        const mainObject = result.data;
        this.workLogObject = mainObject;
        if(this.workLogObject.taskHistory && this.workLogObject.taskHistory.length != 0){
          this.workLogObject.taskHistory.sort().reverse();
        }
      });
  },
  getLocationName(locationId: any,entitytypecodeid:any) {
    if(entitytypecodeid == 20301){
      // let locationObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
      // return locationObj.entityName
      return 'Global'
    }else if(locationId == null){
      return 'N/A'
    }else if(entitytypecodeid != 20301){
    let locationObj = this.locationObject.find((obj: any) => {
      return obj.value == locationId;
    });
    if (locationObj == undefined) {
      let empty = "N/A";
      return empty;
    } else {
      return locationObj.label;
    }
    }
  },
  getLocationNameForSystem(dept:any){    
    if(dept!=undefined){
      let d = this.allEntities.find((Dept:any)=>Dept.departments && Dept.departments.includes(dept));
      if(d==undefined){
        let matchedDept = this.users.find((user:any)=>user._id==dept && user.isRootDepartment && user.isRootDepartment==true);
           const matched = this.locationObject.find((obj: any) => obj.entityType === 1)    
            return matched ? matched.label : 'N/A';
      }
      
      return d ? d.entityDisplayName : 'N/A'
    }
     const matched = this.locationObject.find((obj: any) => obj.entityType === 1);
      return matched ? matched.label : 'N/A';
  },
  async getallEntities() {
    this.locationObject = [];
    let result: any;
    await this.$http
      .get(
        `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
      )
      .then((res: any) => {
        result = res.data;
        this.allEntities = res.data;
      });
    for (var i = 0; i < result.length; i++) {
      this.locationObject.push({
        label: result[i].entityName,
        value: result[i]._id,
        entityType:result[i].entityType
      });
    }
  },
  // getPerson(person: any) {
  // 	this.personObj = this.orgUsersList.find((user: any) => {

  // 		return user._id == person;
  // 	});
  // 	if (this.personObj == undefined) {
  // 		return '';
  // 	} else {
  // 		return this.personObj.name;
  // 	}
  // },
  showpopupOnAdd() {
    this.showPopUp = !this.showPopUp;
    if (this.showPopUp == true) {
      let uuid = uuidv4();   
      const truncatedUuid = uuid.replace(/-/g,'').substring(0, 8)
      this.findingsObject.findingId = truncatedUuid;
      this.findingsObjectDummy.findingId = truncatedUuid;
      this.findingsObject.findingEvidence = "";
      this.findingsObject.finding = "";
      this.findingsObject.findingRelatedTo = "";
      this.findingsObject.control_id = "";
      this.findingsObject.kpi_id = "";
      this.findingsObjectDummy.findingEvidence = "";
      this.findingsObjectDummy.finding = "";
      this.findingsObjectDummy.findingRelatedTo = "";
      this.findingsObjectDummy.control_id = "";
      this.findingsObjectDummy.kpi_id = "";
      delete this.findingsObject.createdBy
      delete this.findingsObject.createdAt 
      delete this.findingsObject.additionalInfo
    }
  },
  onFindingRelatedToChange() {
    const related = Number(this.findingsObject.findingRelatedTo);
    this.findingsObject.kpi_id = "";
    this.findingsObject.control_id = "";
    if (related === 2 && !this.taskHasActiveKpis) {
      this.findingsObject.findingRelatedTo = "";
      return;
    }
    if (related === 1) {
      this.findingsObject.control_id = this.presentTaskObject?.linkedControlID
        ? String(this.presentTaskObject.linkedControlID)
        : "";
    }
  },
  getFindingControlIdFromRecord(obj: any) {
    const raw = obj?.control_id ?? obj?.['control._id'] ?? obj?.control?._id ?? obj?.controlId;
    return raw == null || raw === "" ? "" : String(raw);
  },
  getFindingKpiIdFromRecord(obj: any) {
    const raw = obj?.kpi_id ?? obj?.['kpi._id'] ?? obj?.kpi?._id ?? obj?.controlorKpi;
    return raw == null || raw === "" ? "" : String(raw);
  },
  getTaskMappedControlDisplay() {
    if (!this.presentTaskObject?.linkedControlID) {
      return "N/A";
    }
    return this.presentTaskObject.controlTitle || "N/A";
  },
  getFindingRelatedToDisplay(value: any) {
    if (value == null || value === "") {
      return "N/A";
    }
    return Number(value) === 2 ? "KPI" : "Control";
  },
  getFindingLinkFieldLabel(obj: any) {
    if (obj?.findingRelatedTo == null || obj?.findingRelatedTo === "") {
      return "Control / KPI";
    }
    return Number(obj.findingRelatedTo) === 2 ? "KPI" : "Control";
  },
  getFindingLinkDisplay(obj: any) {
    if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === "") {
      return "N/A";
    }
    if (Number(obj.findingRelatedTo) === 2) {
      const kpiId = this.getFindingKpiIdFromRecord(obj);
      if (kpiId === "") {
        return "N/A";
      }
      const kpi = (this.presentTaskObject.kpis || []).find(
        (k: any) =>
          k._id == kpiId ||
          k._id?.toString() === kpiId
      );
      if (!kpi) {
        return "N/A";
      }
      return kpi.description || kpi.kpi_id || "N/A";
    }
    if (Number(obj.findingRelatedTo) === 1) {
      if (this.getFindingControlIdFromRecord(obj) === "") {
        return "N/A";
      }
      return this.presentTaskObject.controlTitle || "N/A";
    }
    return "N/A";
  },
  buildFindingPayload() {
    const source = this.findingsObject;
    const payload: any = {
      findingId: source.findingId,
      findingEvidence: source.findingEvidence,
      finding: source.finding,
      findingRelatedTo: Number(source.findingRelatedTo),
    };
    const related = Number(source.findingRelatedTo);
    if (related === 1) {
      payload.control_id = String(
        source.control_id || this.presentTaskObject?.linkedControlID || ""
      );
    } else if (related === 2) {
      payload.kpi_id = source.kpi_id;
    }
    return payload;
  },

  showpopupOnAddForResult(val:any) {
    if(val=='addresult'){
      this.resultObject.resultfor = 1
      this.kpiFieldVisibility=false;
      this.showPopUpForResult = !this.showPopUpForResult;
      
    }
    if(val=='addkpi'){
      this.resultObject.resultfor = 2
      this.kpiFieldVisibility=true;
      this.showPopUpForKpi=!this.showPopUpForKpi 
    }

    if(!this.presentTaskObject.kpis || Object.keys(this.presentTaskObject).includes('results') && Object.keys(this.presentTaskObject).includes('kpis') && this.presentTaskObject.results.length == this.presentTaskObject.kpis.length){
      this.resultArray = this.resultArray1
      this.conditionForControlOrKPI = true;
      this.resultObject.resultfor = 1;
      if(this.resultObject.resultfor == 1){
        this.resultObject.controlorKpi = this.presentTaskObject.clientUniqueId
      }
    }
    if((this.controlResultsForCompliance != null || this.controlResultsForCompliance != undefined) && Object.keys(this.presentTaskObject).includes('controlResults') && this.presentTaskObject.controlResults.length == this.controlResultsForCompliance.length){
      this.resultArray = this.resultArray2
      this.conditionForControlOrKPI = true;
      this.resultObject.resultfor = 2;
      if(this.resultObject.resultfor == 2){
        this.resultObject.controlorKpi = ""
      }
    }
    if(val=='addresult'){
      this.resultObject.resultfor = 1
    }
    if(val=='addkpi'){
      this.resultObject.resultfor = 2
    }
    this.resultObjectDummy = {...this.resultObject}
  },
  onCancelButtonAddPopUp() {
    this.showPopUp = false;
    this.kpishowPopUp=false;
    this.onCancelbtn();
  },
  onCancelIcon(){
    this.v$.$reset();
    this.importpopUp = false;
    this.pdfValidation = false;
    this.inputFileName = '';
    this.fileToUpload = '';
    this.fileName = "";
  },
  onCancelButtonAddPopUpForResult() {
    this.v$.$reset();
    this.v$.$touch();
    this.showPopUpForResult = false;
    this.resultObject.resultfor = "";
    this.resultObject.controlorKpi = "";
    this.resultObject.actualOutput = "";
    this.resultObject.totalPopulation = "";
    this.resultObject.riskSeverity = "";
    this.resultObject.comments = "";
    this.resultOfPopulation= true;
    // this.resultOfNegativeOutput= true;
    // this.resultOfNegativePopulation= true;
    this.onCancelbtnForResult();
  },
   onCancelButtonAddPopUpForKpi() {
    this.v$.$reset();
    this.v$.$touch();
    this.showPopUpForKpi = false;
    this.resultObject.resultfor = "";
    this.resultObject.controlorKpi = "";
    this.resultObject.actualOutput = "";
    this.resultObject.totalPopulation = "";
    this.resultObject.riskSeverity = "";
    this.resultObject.comments = "";
    this.resultOfPopulation= true;
    // this.resultOfNegativeOutput= true;
    // this.resultOfNegativePopulation= true;
    this.onCancelbtnForResult();
  },
  getStatusLabel(num: any) {
    let result
    if(num == 10418){
      result = this.terminatedStatus.find((obj: any) => {
        return obj.id == num;
      });
      } else{
        result = this.taskStatusData.find((obj: any) => {
        return obj.id == num;
      });
    }
    // result = this.taskStatusData.find((obj: any) => {
    //     return obj.id == num;
    // });
    
    return result.status!=undefined?result.status:'N/A';
  },
  getBorder() {
    return `numberBorder numberNavy`;
  },
  handleInput() {
    this.btnDisabled = this.comment.length === 0;
  },
  handleComplaintDecimalValue(event: any) {
  this.resultObject.actualOutput = event.target.value.replace(/[^\d]/g, ''); // Only digits, no decimals
  this.checkPopulationValidity(); 
},
handlePopulationDecimalValue(event: any) {
  this.resultObject.totalPopulation = event.target.value.replace(/[^\d]/g, ''); // Only digits, no decimals
  if (!this.isCompliantInputEnabled) {
    this.resultObject.actualOutput = '';
  }
  this.checkPopulationValidity(); 
},
checkPopulationValidity() {
  const population = this.resultObject.totalPopulation;
  const compliant = this.resultObject.actualOutput;
  if (compliant === '' || compliant == null) {
    this.resultOfPopulation = true;
    return;
  }
  this.resultOfPopulation = Number(population) >= Number(compliant);
},

  async addComment() {
    if (this.comment.trim() !== "") {
      const newComment: any = {
        comment: this.comment,
      };
      await this.updateComplianceTask(1, newComment);
      // this.comments.push(newComment);
      this.comment = "";
      this.btnDisabled = true;
    }
  },
  // clearComment() {
  //   this.comment = "";
  //   this.btnDisabled = true;
  // },
  openFilePicker() {
    // this.$refs.fileInput.click();
    // this.v$.$reset();
    this.pdfValidation = false;
    this.importpopUp = true;
  },
  isEvidenceAttachDisabled() {
    return this.TaskDetailsDropDown.taskStatus == 10403 || this.TaskDetailsDropDown.taskStatus == 10417 || this.TaskDetailsDropDown.taskStatus == 10418 || this.TaskDetailsDropDown.taskStatus == 10401;
  },
  formatFileAttachedTime(time: any) {
    return moment(time).format("DD-MM-YYYY");
  },
  openDeleteEvidenceConfirm(evidenceIndex: number) {
    if (evidenceIndex < 0) return;
    this.deleteEvidenceIndex = evidenceIndex;
    this.showDeleteEvidenceConfirm = true;
  },
  cancelDeleteEvidence() {
    this.showDeleteEvidenceConfirm = false;
    this.deleteEvidenceIndex = null;
  },
  async confirmDeleteEvidence() {
    const evidenceIndex = this.deleteEvidenceIndex;
    this.showDeleteEvidenceConfirm = false;
    this.deleteEvidenceIndex = null;
    if (evidenceIndex == null) return;
    await this.removeEvidence(evidenceIndex);
  },
  async removeEvidence(evidenceIndex: number) {
    if (this.isEvidenceAttachDisabled()) return;
    const evidence = this.presentTaskObject?.files?.[evidenceIndex];
    const url = evidence?.url;
    const isUrlEvidence = evidence?.evidenceType === 'url';
    try {
      let urlStillUsed = false;
      if (!isUrlEvidence && url) {
        const tasksResponse = await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`);
        const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
        const currentId = String(this.currentTaskId || '');
        urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.files) && task.files.some((doc: any) => doc?.url === url));
      }
      if (!isUrlEvidence && url && !urlStillUsed) {
        const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
        if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
          return;
        }
      }
      await this.$http.post(
        `${process.env.VUE_APP_MONITOR_API}/task/${this.currentTaskId}/evidence/remove`,
        { evidenceIndex, createdBy: this.userInfo._id }
      );
      await this.getPresentComplianceObject();
      await this.getTasksForCompliance(this.currentComplianceId, this.currentTaskId);
      await this.getTaskHistoryObject();
    } catch (err) {
      toast.error(`Failed to remove evidence`, {
        timeout: 1000,
        closeOnClick: true,
        closeButton: 'button',
        icon: true
      });
    }
  },
  async loadExistingFileOptions() {
    try {
      const [taskRes, capaRes, plannerRes] = await Promise.all([
        this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`),
        this.$http.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`),
        this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`),
      ]);
      const crTasks = (Array.isArray(taskRes?.data) ? taskRes.data : []).filter((task: any) => task?.actionType == 20501);
      const capaTasks = Array.isArray(capaRes?.data) ? capaRes.data : [];
      const plannerTasks = (Array.isArray(plannerRes?.data) ? plannerRes.data : []).map((task: any) => ({
        ...task,
        files: Array.isArray(task?.evidences) ? task.evidences : [],
      }));
      this.linkEvidenceTasks = crTasks.concat(capaTasks, plannerTasks);
    } catch (error) {
      this.linkEvidenceTasks = [];
      toast.error(`Failed to load tasks`, {
        timeout: 1000,
        closeOnClick: true,
        closeButton: 'button',
        icon: true
      });
    }
  },
  resetExistingEvidenceTable() {
    this.existingEvidenceSortKey = '';
    this.existingEvidenceSortDir = 'asc';
    this.showExistingEvidenceFilters = false;
    this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
  },
  toggleExistingEvidenceFilters() {
    this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
    if (!this.showExistingEvidenceFilters) {
      this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
    }
  },
  existingEvidenceTypeLabel(row: any) {
    if (row?.evidenceType === 'url') return String(row.evidenceType).toUpperCase();
    const readExt = (value: any) => {
      const text = String(value || '').split('?')[0];
      const ext = (text.split('.').pop() || '').toLowerCase();
      if (!ext || ext === text.toLowerCase()) return '';
      return ext;
    };
    const ext = readExt(row?.url) || readExt(row?.filename || row?.name);
    return ext ? ext.toUpperCase() : 'File';
  },
  sortExistingEvidence(key: string) {
    if (this.existingEvidenceSortKey === key) {
      this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.existingEvidenceSortKey = key;
      this.existingEvidenceSortDir = 'asc';
    }
  },
  openLinkEvidencePopup() {
    this.selectedExistingEvidences = [];
    this.resetExistingEvidenceTable();
    this.linkEvidencePopup = true;
    this.loadExistingFileOptions();
  },
  closeLinkEvidencePopup() {
    this.linkEvidencePopup = false;
    this.selectedExistingEvidences = [];
  },
  isExistingEvidenceSelected(row: any) {
    return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
  },
  toggleExistingEvidence(row: any) {
    const selected = [...(this.selectedExistingEvidences || [])];
    const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected.push(row);
    }
    this.selectedExistingEvidences = selected;
  },
  async saveLinkedEvidence() {
    const docs = this.selectedExistingEvidences || [];
    const files = docs.filter((doc: any) => doc?.url).map((doc: any) => {
      const filename = doc.filename || doc.name;
      const item: any = {
        url: doc.url,
        filename,
        evidenceDate: doc.evidenceDate,
        evidenceType: doc.evidenceType || 'file'
      };
      if (doc.name) {
        item.name = doc.name;
      }
      if (doc.fileType !== undefined && doc.fileType !== null) {
        item.fileType = doc.fileType;
      }
      if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
        item.linkedEvidenceTaskId = String(doc.sourceTaskId);
      }
      return item;
    });
    if (!files.length) return;
    this.linkEvidencePopup = false;
    this.selectedExistingEvidences = [];
    await this.updateComplianceTask(3, { files });
  },
  handleFileUpload(event: any) {
    const file = this.$refs.fileInput.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileToUpload = file
      const fileNameParts = file.name.split('.');
      fileNameParts.pop(); // Remove the extension
      const nameWithoutExtension = fileNameParts.join('.');
      if (this.inputFileName.trim() === '') {
        this.inputFileName = nameWithoutExtension;
      }
      this.pdfValidation = false;
    } else {
      this.fileName = '';
      this.inputFileName = '';
    }
    let fileExtension = file.name.split(".").pop();
    if (fileExtension == "pdf") {
      this.pdfValidation = false;
      this.v$.$reset();
    } else {
      this.pdfValidation = true
    }
  },  
  async handleFileChange(event: any) {
    let data = this.$refs.fileInput.files[0];
    this.v$.inputFileName.$touch()
    this.v$.fileToUpload.$touch()
    if(((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid) && !this.pdfValidation)){
      this.clickOnButton = true;
    this.importpopUp = !this.importpopUp
      let fileExtension = data.name.split(".").pop();
      // if (fileExtension == "pdf") {
        const fileDataFormat = await this.getConvertDataForFile(data);
        let uuid = uuidv4();
        let payload = {
          fileData: fileDataFormat,
          name: `${uuid}.${fileExtension}`,
        };
        // let folderName = "compliance";
        let folderName = `${process.env.VUE_APP_MONITOR_FOLDER_NAME}`;
        try {
          await this.$http
            .post(
              `${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`,
              payload
            )
            // .post(`http://localhost:4030/services/filemanagement/bucket/${folderName}/file/upload`, payload)
            // bucket/:folderName/file/upload
            .then(async (response: any) => {
              if (response.status == 200) {
                let payload: any = {
                  name: `${uuid}.${fileExtension}`,
                  url: response.data,
                  filename: this.inputFileName,
                };
                await this.updateComplianceTask(3, payload);
                this.inputFileName = ''
                this.fileName = ''
                this.v$.$reset();
              } else {
                // console.log("response status");
              }
            });
        } catch (err) {
          // console.error(err);
        }finally {
          this.clickOnButton = false;
        }
      // } else {
      //   toast.error(`Upload only pdf`, {
      //     timeout: 1000,
      //     closeOnClick: true,
      //     closeButton: "button",
      //     icon: true,
      //   });
      // }
      this.fileName = '';
      this.inputFileName = '';
      this.fileToUpload=null
    }
  },
  async updateComplianceTask(type: any, payload: any) {
    payload.createdBy = this.userInfo._id;
    payload.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
    if (type == 1) {
      // comments
      payload.additionalInfo = { comment: "" };
      payload.additionalInfo.comment = payload.comment;
    } else if (type == 2) {
      // findings — add vs update (audit-style keys); prefer updatedFindingId when edit markers present
      if (payload.updatedAt || payload.updatedBy) {
        payload.additionalInfo = { updatedFindingId: payload.findingId };
      } else {
        payload.additionalInfo = { findingId: payload.findingId };
      }
    } else if (type == 3) {
      if (Array.isArray(payload.files)) {
        payload.files.forEach((item: any) => {
          item.createdBy = payload.createdBy;
          item.taskId = this.presentTaskObject?.taskId;
          item.additionalInfo = { evidence: item.filename, evidenceDate: item.evidenceDate };
        });
      } else {
        // files
        payload.additionalInfo = { evidence: "" };
        payload.additionalInfo.evidence = payload.filename;
      }
    } else if (type == 4) {
      // statusCode
      payload.additionalInfo = { previousStatus: "", updatedStatus: "" };
      payload.additionalInfo.previousStatus =
        this.presentTaskObject.statusCode;
      payload.additionalInfo.updatedStatus = payload.statusCode;
    } else if (type == 5) {
      // results
      if (payload.updatedAt || payload.updatedBy) {
        payload.additionalInfo = {
          resultfor: payload.resultfor,
          kpiName: payload.description,
          updatedActualOutput: payload.actualOutput,
          totalPopulation: payload.totalPopulation,
          riskSeverity: payload.riskSeverity,
        };
      } else {
        payload.additionalInfo = {
          resultfor: payload.resultfor,
          kpiName: payload.description,
          actualOutput: payload.actualOutput,
          totalPopulation: payload.totalPopulation,
          riskSeverity: payload.riskSeverity,
        };
      }
    } else if (type == 6) {
      // assignee
      payload.additionalInfo = { assignee: "" };
      payload.additionalInfo.assignee = payload.assignee;
    } else if (type == 7) {
      // controlResults
      if (payload.updatedAt || payload.updatedBy) {
        payload.additionalInfo = {
          resultfor: payload.resultfor,
          controlorKpi: payload.controlorKpi,
          controlNumber: payload.controlNumber,
          updatedActualOutput: payload.actualOutput,
          totalPopulation: payload.totalPopulation,
          riskSeverity: payload.riskSeverity,
        };
      } else {
        payload.additionalInfo = {
          resultfor: payload.resultfor,
          controlorKpi: payload.controlorKpi,
          controlNumber: payload.controlNumber,
          actualOutput: payload.actualOutput,
          totalPopulation: payload.totalPopulation,
          riskSeverity: payload.riskSeverity,
        };
      }
    }
    try {
      await this.$http
        .post(
          `${process.env.VUE_APP_MONITOR_API}/task/${this.currentTaskId}/type/${type}/update`,
          payload
        )
        .then(async (result: any) => {
          toast.info(`Updated`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: "button",
            icon: true,
          });
          await this.getPresentComplianceObject();
          await this.getTasksForCompliance(
            this.currentComplianceId,
            this.currentTaskId
          );
          await this.getTaskHistoryObject();
          await this.getSingleComplianceFindings();
        });
    } catch {
      toast.error(`error`, {
        timeout: 1000,
        closeOnClick: true,
        closeButton: "button",
        icon: true,
      });
    }finally {
      this.clickOnButtonForFinding = false;
      this.clickOnButtonForResult = false;
    }
  },
  async getAllTeams() {
    this.teamObject = [];
    await this.$http
      .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
      .then((res: any) => {
        this.users = res.data;
      });
    for (var i = 0; i < this.users.length; i++) {
      this.teamObject.push({
        label: this.users[i].teamName,
        value: this.users[i]._id,
      });
    }
  },
  async getConvertDataForFile(data: any) {
    return new Promise((resolve) => {
      const reader: any = new FileReader();
      reader.onload = function () {
        resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
      };
      reader.readAsDataURL(data);
    });
  },
  async getallUsers() {
    await this.$http
      .get(`${process.env.VUE_APP_ORG_API}/users/getAll`)
      .then((res: any) => {
        this.orgUsersList = res.data;
        this.orgUsersList.map((obj:any)=>{
          this.optionsUsersList.push({value : obj._id , label : obj.name});
          
          
          // let newObj = obj
        })
        for (var i = 0; i < this.orgUsersList.length; i++) {
          // if (this.userInfo._id !== this.orgUsersList[i]._id) {
          //   this.optionsUsersList.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
          // }
          // if (this.orgUsersList[i].isActive == true) {
            this.optionsUserArray.push({
              label: this.orgUsersList[i].name,
              value: this.orgUsersList[i]._id,
            });
          // }
        }
      });
  },
  async getPresentComplianceObject() {
    await this.$http
      .get(
        `${process.env.VUE_APP_MONITOR_API}/api/org/compliance/${this.currentComplianceId}/get`
      )
      .then((result: { data: any }) => {
        this.presentComplianceObject = result.data;
      })
      .catch((error: any) => {
        toast.error(`error`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      });
  },
  async getSingleComplianceFindings(cId:any) {
      this.findingsForCompliance = this.presentTaskObject?.findingRecords || [];
  },
  async getTasksForCompliance(cId: any, tId: any) {
    this.tasksForCompliance = [];
    this.resultsForCompliance = [];
    this.controlResultsForCompliance = [];
    this.tabDataLoading = true
    try {
      await this.$http
        .get(
          `${process.env.VUE_APP_MONITOR_API}/api/org/compliance/${cId}/tasks/get`
        )
        .then((result: any) => {
          this.tasksForCompliance = result.data;
          let present = result.data.find((obj: any) => {
            return obj._id == tId;
          });
          this.presentTaskObject = { ...present };
          this.findingsForCompliance = this.presentTaskObject?.findingRecords || [];
          this.kpisObject = this.presentTaskObject.kpis || [] ;
          this.TaskDetailsDropDown.taskStatus = this.presentTaskObject.statusCode;
          let teamLeaderObj: any 
          let teamReviewer:any
          if(Object.keys(this.presentTaskObject).includes('assignee') && this.presentTaskObject.assignee !== undefined){
            teamLeaderObj = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentTaskObject.assignee;
            });
          } else{
            teamLeaderObj = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentTaskObject.teamOwner;
            });
          }
          if(Object.keys(this.presentTaskObject).includes('reviewer') && this.presentTaskObject.reviewer !== undefined){
            teamReviewer = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentTaskObject.reviewer;
            });
          } else{
            teamReviewer = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentTaskObject.reviewer;
            });
          }
          this.presentComplianceObject.teamLeader = teamLeaderObj||'N/A';
          if(teamLeaderObj != undefined || teamLeaderObj != null || teamLeaderObj != ''){
            this.teamLeaderValue = teamLeaderObj.value
          }
          if(teamReviewer != undefined || teamReviewer != null || teamReviewer != ''){
            this.teamReviewerValue = teamReviewer.value
          }
          if(Object.keys(this.presentTaskObject).includes('comments') && this.presentTaskObject.comments.length != 0){
            // const decodedComment = Buffer.from(obj.comment, 'base64').toString('utf-8');
            let commentsArray: any = [];
            this.presentTaskObject.comments.forEach((commentObj: any)=>{
              commentObj.comment = atob(commentObj.comment)

              commentsArray.push(commentObj);
            })
            this.presentTaskObject.comments = commentsArray
            this.presentTaskObject.comments = this.presentTaskObject.comments.sort().reverse();
          }
          if(Object.keys(this.presentTaskObject).includes('results') && this.presentTaskObject.results.length !== 0){
            let resultObj: any = {};
            // let allPerformanceOutputs: any = []
            let populationValue
            let compliantValue
            let resultfor
            let controlorKpi
            this.presentTaskObject.results.forEach((eachResult:any)=>{
              let allPerformanceOutputs: any = []
              resultfor = eachResult.resultfor
              controlorKpi = eachResult.controlorKpi
              populationValue = 0;
              compliantValue = 0;
              populationValue = eachResult.totalPopulation
              compliantValue = eachResult.actualOutput
              let performanceOutput = eachResult.totalPopulation && eachResult.actualOutput ? (eachResult.actualOutput / eachResult.totalPopulation)* 100 : 0;
              allPerformanceOutputs.push(Math.round(performanceOutput))
              resultObj.comments = eachResult.comments
              this.kpiProgress = 0;
              if(compliantValue != populationValue){
                // this.kpiProgress = allPerformanceOutputs.length!==0 ? allPerformanceOutputs.performanceOutput: 0
                this.kpiProgress = allPerformanceOutputs.length!==0 ? Math.ceil(allPerformanceOutputs.reduce((acc: any, currentValue: any) => acc + Number(currentValue))/allPerformanceOutputs.length) : 0;
              } else{
                this.kpiProgress = 100
              }
              eachResult.kpiProgress = this.kpiProgress
              this.severity = this.riskSeverity(this.kpiProgress/4);
              eachResult.resultfor = resultfor
              eachResult.controlorKpi = controlorKpi
              eachResult.totalPopulation = populationValue
              eachResult.actualOutput = compliantValue
              eachResult.severity = this.severity
              
            })
            resultObj.resultfor = resultfor
            resultObj.controlorKpi = controlorKpi
            resultObj.totalPopulation = populationValue
            resultObj.actualOutput = compliantValue
            resultObj.severity = this.severity
            this.resultsForCompliance.push(resultObj)
            // resultObj.performanceOutput = this.kpiProgress
            
          }
          if(Object.keys(this.presentTaskObject).includes('controlResults') && this.presentTaskObject.controlResults.length !== 0){
            let resultObj: any = {};
            let populationValue
            let compliantValue
            let resultfor
            let controlNumber
            this.presentTaskObject.controlResults.forEach((eachResult:any)=>{
              
              resultfor = eachResult.resultfor
              controlNumber = this.presentTaskObject.clientUniqueId
              populationValue = eachResult.totalPopulation ?? eachResult.population
              compliantValue = eachResult.actualOutput ?? eachResult.compliant
              const isMissing = (value: any) => value == null || value === '';
              const hasNullCompliant = isMissing(compliantValue);
              const storedResultValue = eachResult.control_result_value ?? eachResult.control_ResultValue ?? eachResult.controlResultValue;
              const storedHealth = eachResult.control_health ?? eachResult.controlHealth;
              const storedSeverity = eachResult.control_risk_severity ?? eachResult.control_RiskSeverity ?? eachResult.controlRiskSeverity ?? eachResult.riskSeverity ?? eachResult.severity;
              const calculatedValue = populationValue && !hasNullCompliant ? Math.round((compliantValue / populationValue) * 100) : null;
              const controlResultValue = !isMissing(storedResultValue)
                ? Number(storedResultValue)
                : calculatedValue;
              const controlHealth = !isMissing(storedHealth)
                ? Number(storedHealth)
                : (hasNullCompliant ? null : (Number(compliantValue) === Number(populationValue) ? 100 : controlResultValue));
              this.controlProgress = controlResultValue;
              this.severity = isMissing(storedSeverity) ? 'N/A' : storedSeverity;
              if (hasNullCompliant) {
                compliantValue = 'N/A';
              }
              resultObj.comments = eachResult.comments
              resultObj.controlResultValue = controlResultValue
              resultObj.controlHealth = controlHealth
            })
            resultObj.resultfor = resultfor
            resultObj.controlorKpi = controlNumber
            resultObj.totalPopulation = populationValue
            resultObj.actualOutput = compliantValue
            resultObj.severity = this.severity
            resultObj.controlProgress = this.controlProgress
            this.controlResultsForCompliance.push(resultObj)
          }
          this.controlsArray = this.presentTaskObject.frameworks.filter((obj : any)=>{
              return this.presentComplianceObject.frameworks.includes(obj.framework)
          })
          this.controlsArray.forEach((item: any) => {
              this.controlDetailsArray = item.controls.map((controlNumber: any) => this.getControlDetails(controlNumber)).filter(Boolean);
              item.controlsDetailsArray = this.controlDetailsArray;
              delete item.controls;
          });

          this.evidenceArray = []
            if(this.presentTaskObject.files){
              this.presentTaskObject.files.forEach((fileObj: any) => {
                this.evidenceArray.push(fileObj.filename)
              });
            }
        });
    } catch {
      // toast.error(`error 44`, {
      //   timeout: 1000,
      //   closeOnClick: true,
      //   closeButton: "button",
      //   icon: true,
      // });
    }
    this.tabDataLoading = false
  },
  getControlDetails(controlNumber: any) {
    const control = this.allFrameWorkControls.find(
      (item: any) => item.controlNumber === controlNumber
    );
    return control
      ? {
          controlNumber: control.controlNumber,
          description: control.controlAuditMethodology,
        }
      : null;
  },
  // /api/org/controls/:controlId/documents/get
  // async getControlDocuments() {
  //   await this.$http
  //     .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/:controlId/documents/get`)
  //     .then((result: { data: any }) => {
  //       this.eachControlDocuments = result.data;
  //     })
  //     .catch((error: any) => {
  //       toast.error(`error`, {
  //         timeout: 1000,
  //         closeOnClick: true,
  //         closeButton: "button",
  //         icon: true,
  //       });
  //     });
  // },
  async getControls() {
    await this.$http
      .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
      .then((result: { data: any }) => {
        this.allFrameWorkControls = result.data;
        const groupedControlsFrameworks = groupBy(
          result.data,
          "controlFrameWork"
        );
        const listOfFrameworks = Object.keys(groupedControlsFrameworks);
        listOfFrameworks.forEach((key) => {
          this.complianceFrameworkArray.push(key);
        });
      })
      .catch((error: any) => {
        toast.error(`error`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      });
  },
  onCancelbtn() {
    this.v$.$reset();
    this.findingsObject = { ...this.findingsObjectDummy };
  },
  onCancelbtnForResult() {
    this.v$.$reset();
    this.resultObject = {...this.resultObjectDummy}
    this.resultOfPopulation= true;
    // this.resultOfNegativeOutput= true;
    // this.resultOfNegativePopulation= true;
    this.conditionForControlOrKPI = false;
  },
  riskSeverity(value: number) {
      if (value <= 5) {
          return 1;
      } else if (value > 5 && value <= 10) {
          return 2;
      } else if (value > 10 && value <= 15) {
          return 3;
      } else if (value > 15 && value <= 20) {
          return 4;
      } else if (value > 20 && value <= 25) {
          return 5;
      }
  },
  // riskSeverity(value: number) {
  //     if (value <= 20) {
  //         return 1;
  //     } else if (value > 20 && value <= 40) {
  //         return 2;
  //     } else if (value > 40 && value <= 60) {
  //         return 3;
  //     } else if (value > 60 && value <= 80) {
  //         return 4;
  //     } else if (value > 80 && value <= 100) {
  //         return 5;
  //     }
  // },
  async addFindingButton() {
    this.v$.$touch();
    if (!this.v$.findingsObject.$invalid) {
      this.clickOnButtonForFinding = true;
      let payload = this.buildFindingPayload();
      await this.updateComplianceTask(2, payload);
      this.showPopUp = false;
      this.onCancelbtn();
    }
  },
  // validateResultObject() {
  //   // Ensure the fields are not empty
  //   if (!this.resultObject.actualOutput || !this.resultObject.totalPopulation) {
  //     alert('Both Actual Output and Total Population are required.');
  //     toast.error(`Both Actual Output and Total Population are required`, {
  //       timeout: 1000,
  //       closeOnClick: true,
  //       closeButton: "button",
  //       icon: true,
  //     });
  //     return false;
  //   }
    
  //   // Ensure the values are non-negative
  //   if (parseFloat(this.resultObject.actualOutput) < 0 || parseFloat(this.resultObject.totalPopulation) < 0) {
  //     // alert('Values must be non-negative.');
  //     toast.error(`Values must be non-negative`, {
  //       timeout: 1000,
  //       closeOnClick: true,
  //       closeButton: "button",
  //       icon: true,
  //     });
  //     return false;
  //   }
    
  //   // Ensure Total Population is greater than or equal to Actual Output
  //   if (parseFloat(this.resultObject.totalPopulation) < parseFloat(this.resultObject.actualOutput)) {
  //     // alert('Total Population must be greater than or equal to Actual Output.');
  //     toast.error(`Total Population must be greater than or equal to Actual Output`, {
  //       timeout: 1000,
  //       closeOnClick: true,
  //       closeButton: "button",
  //       icon: true,
  //     });
  //     return false;
  //   }

  //   // If Total Population is equal to Actual Output, set progress to 100
  //   if (parseFloat(this.resultObject.totalPopulation) === parseFloat(this.resultObject.actualOutput)) {
  //     this.progress = 100;
  //   }

  //   return true;
  // },
  // async addResultButtonForTask() {
  //   // Perform validation
  //   const isValid = this.validateResultObject();
  //   if (!isValid) return;

  //   // Proceed with the rest of the logic
  //   this.showPopUpForResult = false;
  //   let payload = this.resultObject;
  //   await this.updateComplianceTask(5, payload);
  //   this.resultObject.actualOutput = "";
  //   this.resultObject.totalPopulation = "";
  //   this.resultObject.comments = "";
  // }
  // async addResultButtonForTask(data:any) {
  //   this.v$.$touch();
  //   // parseFloat(this.resultObject.totalPopulation) === parseFloat(this.resultObject.actualOutput)
  //   if(parseFloat(data.totalPopulation) >= parseFloat(data.actualOutput)){
  //     if (!this.v$.resultObject.$invalid) {
  //       // if (parseFloat(this.resultObject.totalPopulation) === parseFloat(this.resultObject.actualOutput)) {
  //       //   this.progress = 100;
  //       // }
  //       this.showPopUpForResult = false;
  //       let payload = this.resultObject;
  //       await this.updateComplianceTask(5, payload);
  //       this.resultObject.actualOutput = "";
  //       this.resultObject.totalPopulation = "";
  //       this.resultObject.comments = "";
  //       this.v$.$reset()
  //       // this.onCancelbtnForResult();
  //     }
  //   } else {
  //     this.greaterThanOrEqualActual = true
  //     // toast.error(`Population must be greater than Compliant`, {
  //     //     timeout: 6000,
  //     //     closeOnClick: true,
  //     //     closeButton: "button",
  //     //     icon: true,
  //     //   });
  //   }
  // },
  // changingResultObject(value: any){
  //   this.isTotalPopulationValid()
  //   this.isNonNegative(value);
  // },
  isNonNegative(value: any) {
    return parseFloat(value) >= 0;
  },
  isTotalPopulationValid() {
    this.checkPopulationValidity();
    return this.resultOfPopulation;
  },
  validateResultObject() {
    // const { actualOutput, totalPopulation } = this.resultObject;
    // const isNonNegativeOutput = this.isNonNegative(actualOutput);
    // this.resultOfNegativeOutput = isNonNegativeOutput;
    // const isNonNegativePopulation = this.isNonNegative(totalPopulation);
    // this.resultOfNegativePopulation = isNonNegativePopulation;
    const isTotalPopValid = this.isTotalPopulationValid();
    return isTotalPopValid;
  },
  async updateTaskForTeamLeader(assignee: any){
    let payload: any = { assignee: assignee.value };
    await this.updateComplianceTask(6, payload);
     if(this.presentComplianceObject.teamLeader != undefined){
        this.newTeamLeader = this.presentComplianceObject.teamLeader
      }
  },
  async addResultButtonForTask() {
    
    this.v$.$touch();
  const isValid =
  !this.v$.resultObject.actualOutput.$error &&
  !this.v$.resultObject.totalPopulation.$error &&
  !this.v$.resultObject.riskSeverity.$error &&
  !this.v$.resultObject.comments.$error && this.isTotalPopulationValid();
    
    if (!isValid || this.resultObject.comments == "") return;
    this.clickOnButtonForResult = true;

    // Proceed with the rest of the logic
    this.showPopUpForResult = false;
    this.showPopUpForKpi=false;
    this.conditionForControlOrKPI = false;
    let payload = this.resultObject;
    if (Number(payload.totalPopulation) === 0) {
      payload.actualOutput = null;
    }
    // if (parseFloat(this.resultObject.totalPopulation) === parseFloat(this.resultObject.actualOutput)) {
    //   this.progress = 100;
    // }
    payload.resultfor = 1;
    payload.riskSeverity = Number(payload.riskSeverity);
    await this.updateComplianceTask(7, payload);
    
    
    this.resultObject.resultfor = ""
    this.resultObject.controlorKpi = ""
    this.resultObject.actualOutput = "";
    this.resultObject.totalPopulation = "";
    this.resultObject.riskSeverity = "";
    this.resultObject.comments = "";
    this.v$.$reset();
  },
  async addResultButtonForTaskKpi() {
  this.v$.$touch(); 
  const isValid =
  !this.v$.resultObject.controlorKpi.$error &&
  !this.v$.resultObject.actualOutput.$error &&
  !this.v$.resultObject.totalPopulation.$error &&
  !this.v$.resultObject.riskSeverity.$error &&
  !this.v$.resultObject.comments.$error && this.isTotalPopulationValid();

    
    if (!isValid || this.resultObject.comments == "") return;
    this.clickOnButtonForResult = true;

    // Proceed with the rest of the logic
    this.showPopUpForResult = false;
    this.showPopUpForKpi=false;
    this.conditionForControlOrKPI = false;
    let payload = this.resultObject;
    // if (parseFloat(this.resultObject.totalPopulation) === parseFloat(this.resultObject.actualOutput)) {
    //   this.progress = 100;
    // }
    if (payload.resultfor === 2 && !this.storingKpiIds.includes(payload.controlorKpi)) {
      this.storingKpiIds.push(payload.controlorKpi);
    }
    payload.resultfor = 2;
    payload.riskSeverity = Number(payload.riskSeverity);
    await this.updateComplianceTask(5, payload);
    
    
    this.resultObject.resultfor = ""
    this.resultObject.controlorKpi = ""
    this.resultObject.actualOutput = "";
    this.resultObject.totalPopulation = "";
    this.resultObject.riskSeverity = "";
    this.resultObject.comments = "";
    this.v$.$reset();
  },

},
});
</script>